<template>
  <div>
    <div v-if="!isCheckCapacity" v-show="Products && Products.length > 0" class="row-tb-head" style="margin: 10px 0">
      <template
        ><span>预计完工日期</span>
        <span style="margin: 0 10px"> <el-date-picker v-model="batchShowEndTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"> </el-date-picker> </span
      ></template>
    </div>
    <div v-if="!isCheckCapacity" style="display: flex; font-size: 14px; line-height: 30px; color: #606266; margin-bottom: 10px">
      <div>多选操作：</div>
      <div style="display: flex">
        <div></div>
        <div style="margin: 0 10px">
          <el-date-picker :disabled="!selList.length" v-model="batchDocDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="批量修改选中单据日期" @change="onDocDate">
          </el-date-picker>
        </div>
      </div>
      <div style="display: flex">
        <div></div>
        <div style="margin: 0 10px">
          <el-date-picker
            :disabled="!selList.length"
            v-model="batchEndTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="批量修改选中预计完工日期"
            @change="onDocEndTime"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="flex2">
        <div>生产部门</div>
        <div style="margin: 0 10px">
          <dp-select ref="dpSelect" style="width: 180px" @input="changeDp" v-model="DpId" :disabled="!selList.length" />
        </div>
      </div>
    </div>
    <el-table
      :data="Products"
      class="table_bottom table-line tb-c-head"
      border
      max-height="353"
      @row-click="rowClick"
      :row-class-name="tableRowClassName"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column type="index" label="序号" fixed="left" />
      <el-table-column prop="OrderProductNo" label="布产单号" min-width="120" v-if="!isCheckCapacity"></el-table-column>
      <el-table-column prop="WorkDocNo" label="工单号" min-width="120" v-if="!isCheckCapacity"></el-table-column>
      <el-table-column prop="Pno" label="产品编码" min-width="120"></el-table-column>
      <el-table-column prop="Pname" label="产品名称" min-width="120" fixed="left"></el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="120" v-if="!isCheckCapacity"></el-table-column>
      <el-table-column prop="BatchNumber" label="批号" min-width="120" v-if="!isCheckCapacity"></el-table-column>
      <el-table-column prop="PdUnitName" label="单位" min-width="120"></el-table-column>
      <el-table-column prop="BarCode" label="存货条码" min-width="120"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="120">
        <template slot-scope="{ row }">
          <el-select filterable v-if="Status === 0" v-model="row.PropertyId" v-show="row.UseProcess" @change="changeProperty($event, row)">
            <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
          </el-select>
          <span v-else>{{ row.PropertyName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-select filterable v-if="Status === 0" v-model="row.ColorId" v-show="row.UseColor" @change="changeColor($event, row)">
            <el-option v-for="item in row.Colors" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName"></el-option>
          </el-select>
          <span v-else>{{ row.ColorName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="TrademarkNo" label="商标" min-width="120">
        <template slot-scope="{ row }">
          <account-select
            v-if="Status == 0 && mstage.UseTradeMark"
            v-model="row.TrademarkNo"
            :source="MarkAccount"
            :Head="MarkHead"
            @select="onMarkSelect($event, row)"
            :pageSize="pageMarkParams.pageSize"
            :pageIndex="pageMarkParams.pageIndex"
            :listTotal="listMarkTotal"
            @inputText="inputMarkText"
            @click.native="resetMarkFun(row)"
            @currentPage="currentMarkPage($event, row)"
            :pageType="true"
            :clearable="true"
            :isShowClear="true"
            @clear="onMarkClear(row)"
          />
          <span v-else>{{ mstage.UseTradeMark ? row.TrademarkNo : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="MarkLocation" label="印刷位置" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.MarkLocation" type="text" @change="editT(row)" v-if="Status === 0 && mstage.UseTradeMark"></el-input>
          <span v-else>{{ mstage.UseTradeMark ? row.MarkLocation : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Wages" label="加工单价" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.Wages" type="text" @change="editT(row)" v-if="Status === 0"></el-input>
          <span v-else>{{ row.Wages }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="需求数量" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-if="Status === 0" v-model="row.qua" v-quantity:[option]="option" @change="changePQuantity($event, row)" />
          <span v-else>{{ $commonJs.toThousands(row.qua) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ImgUrl" label="产品图片" min-width="120">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="Remarks" label="备注" v-if="!isCheckCapacity" />
      <!-- <el-table-column prop="ProcessStage" label="加工阶段" min-width="120">
        <template slot-scope="{ row }">
          <span>{{
            (() => {
              if (row.ProcessStage === 4) {
                return "组合";
              } else if (row.ProcessStage === 3) {
                return "装配";
              } else if (row.ProcessStage === 1) {
                return "注塑";
              } else if (row.ProcessStage === 2) {
                return "配件";
              } else if (row.ProcessStage === 0) {
                return "无";
              }
            })()
          }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="ProduceTypeName" label="存货类型" min-width="120"></el-table-column>

      <el-table-column prop="StockQuantity" label="库存数量" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ExistQuantity" label="可用量" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="生产数量" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <span>{{ row.qua }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="InQuantity" label="累计入库数" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.InQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="未入库数" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <span>{{ row.qua && row.InQuantity ? (row.qua - row.InQuantity > 0 ? row.qua - row.InQuantity : 0) : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="PickingWarehouseId" label="预入仓" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-select v-model="row.PickingWarehouseId" @change="onWarehouse($event, row)">
            <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="PickingWarehousePositionId" label="预入库位" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-select v-model="row.PickingWarehousePositionId" @visible-change="onChangeWarehousePosition($event, row, row.PickingWarehouseId)">
            <el-option v-for="item in row.WarehousePositionList" :key="item.WarehousePositionId" :label="item.WarehousePositionName" :value="item.WarehousePositionId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="UnqualifiedInWarehouseId" label="不合格预入仓" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-select v-model="row.UnqualifiedInWarehouseId" @change="onWarehouse($event, row)">
            <el-option v-for="item in warehouseList" :key="item.UnqualifiedInWarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column key="column1" v-if="!QuickProcess" prop="SchedulingType" label="排产类型" min-width="120">
        <template slot-scope="{ row }">
          <el-select v-if="Status === 0" v-model="row.SchedulingType" @change="changeSchedulingType($event, row)" v-show="!QuickProcess">
            <el-option key="SchedulingType1" label="部门" :value="0"></el-option>
            <el-option key="SchedulingType2" v-show="row.ProductionType === 0" label="设备" :value="1"></el-option>
          </el-select>
          <span v-show="!QuickProcess" v-else>{{ row.SchedulingType === 0 ? '部门' : '设备' }}</span>
        </template>
      </el-table-column>
      <el-table-column key="column2" v-if="!QuickProcess" label="生产部门/设备" min-width="120">
        <template slot-scope="{ row }">
          <dp-select v-if="row.SchedulingType === 0" style="width: 180px" :disabled="Status === 1" @input="editT(row)" v-model="row.DpId" v-show="row.showDp" />
          <el-select v-else style="width: 180px" @input="editT(row)" :disabled="Status === 1" v-model="row.MaintenanceId" v-show="row.showMt" @change="changeEquipment(row, $event)">
            <el-option v-for="item in equipmentList" :key="item.EquipmentId" :label="item.EquipmentName" :value="item.EquipmentId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="生产部门" min-width="120" key="column2" v-else>
        <template slot-scope="{ row }">
          <dp-select v-show="row.ProductionType == 0" style="width: 180px" @input="editT(row)" :disabled="Status === 1" v-model="row.DpId" />
        </template>
      </el-table-column>

      <el-table-column prop="ProductionType" label="生产类型" min-width="120">
        <template slot-scope="{ row }">
          <el-select v-model="row.ProductionType" @change="editT(row)" v-if="Status === 0">
            <el-option v-if="row.currentProductNature === 2 || row.currentProductNature === 0" key="ProductionType1" label="自产" :value="0"></el-option>
            <el-option v-if="row.currentProductNature === 2 || row.currentProductNature === 1" key="ProductionType2" label="委外" :value="1"></el-option>
          </el-select>
          <span v-else>{{ row.ProductionType === 0 ? '自产' : '委外' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="ProductionDpId" label="加工商" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <!-- <dp-select
            v-if="row.ProductionType !== 1"
            style="width: 180px"
            @input="editT(row)"
            :disabled="Status === 1"
            v-model="row.ProductionDpId"
          /> -->
          <el-select v-model="row.ProductionDpId" @change="editT(row)" v-if="row.ProductionType === 1" :disabled="row.ProductionType === 1 && Status !== 0" filterable>
            <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="DocDate" label="单据日期" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-date-picker v-if="Status === 0" v-model="row.DocDate" @change="editT(row)" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
          <span v-else>{{ row.DocDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="EndTime" label="预计完工日期" min-width="180">
        <template slot-scope="{ row }">
          <el-date-picker v-if="Status === 0" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" v-model="row.EndTime" @change="editT(row)" type="datetime" placeholder="选择日期">
          </el-date-picker>
          <span v-else>{{ row.EndTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="工单备注" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-input v-model="row.Remark" type="text" @change="editT(row)" v-if="Status === 0"></el-input>
          <span v-else>{{ row.Remark }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Bomno" label="BOM版本号" min-width="120"></el-table-column>
      <el-table-column label="设计图" prop="PdImgs" align="center" min-width="100">
        <template slot-scope="{ row }">
          <el-button v-if="Status === 0" type="text" @click="uploadImg(row)">上传</el-button>
          <el-button v-else type="text" @click="viewImg2(row)">{{ row.PdImgs != null ? '查看' : '' }} </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="delPro(row, $index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-tabs v-model="activeName" type="card" v-show="isShowTabs">
      <el-tab-pane label="产品子件" name="2">
        <div class="flex1" v-if="Status === 0">
          <div>{{ isShowTabs ? itemDetailModels[0].Pname : '' }}</div>
          <el-button type="primary" v-show="isShowTabs" @click="add">添加</el-button>
        </div>
        <div v-for="(item, index) in itemDetailModels" :key="index">
          <el-table v-if="itemDetailModels" :data="item.DetailModels" class="table_bottom table-line tb-c-head" border>
            <el-table-column prop="Pno" label="子件编码" min-width="120"></el-table-column>
            <el-table-column prop="Pname" label="子件名称" min-width="120">
              <template slot-scope="{ row, $index }">
                <account-select
                  v-if="Status === 0"
                  v-model="row.Pname"
                  :source="DAccount"
                  @select="onSelect($event, row, $index)"
                  :pageSize="pageParams.pageSize"
                  :pageIndex="pageParams.pageIndex"
                  :listTotal="listTotal"
                  @inputText="inputText"
                  @click.native="resetFun"
                  @currentPage="currentPage"
                  :pageType="true"
                />
                <span v-else>{{ row.Pname }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ProductSpec" label="规格" min-width="120"></el-table-column>
            <el-table-column prop="BatchNumber" label="批号" min-width="120"></el-table-column>
            <el-table-column prop="PdUnitName" label="单位" min-width="120"></el-table-column>
            <el-table-column prop="BarCode" label="存货条码" min-width="120"></el-table-column>
            <el-table-column prop="PropertyName" label="属性" min-width="120">
              <template slot-scope="{ row }">
                <el-select filterable v-if="Status === 0" v-model="row.PropertyId" v-show="row.UseProcess" @change="changeProperty($event, row)">
                  <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
                </el-select>
                <span v-else>{{ row.PropertyName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ColorName" label="颜色" min-width="120">
              <template slot-scope="{ row }">
                <el-select filterable v-if="Status === 0" v-model="row.ColorId" v-show="row.UseColor" @change="changeColor($event, row)">
                  <el-option v-for="item in row.Colors" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName"></el-option>
                </el-select>
                <span v-else>{{ row.ColorName }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="Quantity" label="需求数量" min-width="120">
              <template slot-scope="{ row }">
                <el-input v-if="Status === 0" clearable @change="changeQua($event, row, item)" v-model="row.qua" placeholder="请输入数量" type="number" v-quantity:[option]="option" />
                <span v-else>{{ $commonJs.toThousands(row.qua) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="OutWarehouseId" label="预出仓" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.OutWarehouseId" @change="onWarehouse($event, row)">
                  <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="OutWarehousePositionId" label="预出库位" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.OutWarehousePositionId" @visible-change="onChangeWarehousePosition($event, row, row.OutWarehouseId)">
                  <el-option v-for="item in row.WarehousePositionList" :key="item.WarehouseId" :label="item.WarehousePositionName" :value="item.WarehousePositionId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="ImgUrl" label="产品图片" min-width="120">
              <template slot-scope="{ row }">
                <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="Remark" label="备注" />
            <!-- <el-table-column
              prop="ProcessStage"
              label="加工阶段"
              min-width="120"
            >
              <template slot-scope="{ row }">
                <span>{{
                  (() => {
                    if (row.ProcessStage === 4) {
                      return "组合";
                    } else if (row.ProcessStage === 3) {
                      return "装配";
                    } else if (row.ProcessStage === 1) {
                      return "注塑";
                    } else if (row.ProcessStage === 2) {
                      return "配件";
                    } else if (row.ProcessStage === 0) {
                      return "无";
                    }
                  })()
                }}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="ProduceTypeName" label="存货类型" min-width="120"> </el-table-column>
            <el-table-column label="注塑bom版本号" prop="MouldBomNo" align="center" min-width="120">
              <template slot-scope="{ row }">
                <!-- <span  >{{row.BomNo}}</span> -->
                <child-select
                  v-show="row.MouldId != null && row.ProduceTypeName === '胶件' && row.PropertyName === '注塑'"
                  v-model="row.MouldBomNo"
                  :source="row.MouldBomNos"
                  :Head="[
                    { Value: 'MouldNo', Name: '模具编码', Width: '150' },
                    { Value: 'MouldName', Name: '模具名称', Width: '120' },
                    { Value: 'Bomno', Name: '版本号', Width: '120' }
                  ]"
                  @select="onSelectMouldBomNo($event, row)"
                  :pageType="false"
                />
              </template>
            </el-table-column>
            <el-table-column prop="StockQuantity" label="库存数量" min-width="120">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="ExistQuantity" label="可用量" min-width="120">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="PickingQuantity" label="已领用数量" min-width="120">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.PickingQuantity) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ConsumeQuantity" label="已耗用数量" min-width="120">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.ConsumeQuantity) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" align="center" width="80">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="del(item, row, $index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="工艺" name="1">
        <div v-for="(item, index) in itemProcessModels" :key="index">
          <div class="flex1">
            <div class="flex2">
              <div class="mr8">{{ item.ProgrammeName }}</div>
              <el-button type="primary" @click="changeProgramme(item, index)">选择方案</el-button>
            </div>
          </div>
          <el-table :data="item.Processes" class="table_bottom table-line tb-c-head" border ref="list3">
            <el-table-column prop="ProcessId" label="工序名称" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.ProcessId">
                  <el-option v-for="(item, index) in teProcessList" :key="index" :value="item.ProcessId" :label="item.ProcessName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="ProductionType" label="自制工序或者委外工序" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.ProcessType" @change="changeProcessType(row)" :disabled="disabled">
                  <el-option key="a1" label="自制工序" :value="0"></el-option>
                  <el-option key="a2" label="委外工序" :value="1"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="TradeUnitId" label="委外供应商" min-width="120">
              <template slot-scope="{ row }">
                <div class="flex" v-show="row.ProcessType === 1">
                  <span v-if="disabled">{{ row.TradeUnitName }}</span>
                  <el-input v-else type="text" v-model="row.TradeUnitName" readonly />
                  <el-button v-if="!disabled" type="primary" @click="selectCome(row)">选择</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- <div class="row-tb-head" style="margin-top: 10px">
      <span>工艺</span>
    </div> -->

    <!-- <div class="row-tb-head" style="margin-top: 10px">
      <span>产品子件</span>
    </div> -->

    <come-list-dialog @select="comeSelect" selectable :multiple="false" ref="comeListDialog" in-dialog />
    <detail-dialog ref="detailDialog" @saved="detail_saved"></detail-dialog>
    <img-dialog ref="imgDialog" :imgs="imgs" />
    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <bom-pd-img-dialog ref="bomPdImgDialog" @saved="img_saved" />
  </div>
</template>
<script>
import accountSelect from '../select'
import comeListDialog from '@/components/basedata/business/come/listDialog'
import detailDialog from './detailDialog'
import { urlHttp } from './bomConfig'
import imgDialog from './imgDialog'
import dpSelect from './dpSelect'
import vSelect from './vSelect'
import listDialog from '@/components/production/craftsmanship/solutions/assembly/listDialog'
import childSelect from '@/components/business/stock/childSelect'
import bomPdImgDialog from '@/components/production/craftsmanship/bom/bomPdImgDialog'

export default {
  components: {
    accountSelect,
    comeListDialog,
    detailDialog,
    imgDialog,
    dpSelect,
    vSelect,
    listDialog,
    childSelect,
    bomPdImgDialog
  },
  data() {
    return {
      sumData: [],
      tableData: [],
      sumTableData: [],
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      tradeUnitList: [],
      propertyApi: require('@/api/ba/property').default,
      pdApi: require('@/api/ba/product').default,
      teProcessApi: require('@/api/production/teProcess').default,
      teMouldBomApi: require('@/api/production/teMouldBom').default,
      warehousePositionApi: require('@/api/ba/warehousePosition').default,
      equipmentApi: require('@/api/ba/equipment').default,
      workdocApi: require('@/api/production/workDoc').default,
      trademarkApi: require('@/api/ba/trademark').default,
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        Quantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true
      },
      warehousePositionList: [],
      teProcessList: [],
      disabled: false,
      propertyList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      currentRow: null,
      programmeCurrentRow: null,
      programmeCurrentIndex: null,
      DetailModels: [],
      delDetailModels: [],
      Products: [],
      ProcessModels: [],
      imgs: [],
      deleteProducts: [],
      deleteProcessModels: [],
      deleteDetailModels: [],
      deleteLineDetailModels: [],
      equipmentList: [],
      activeName: '2',
      itemProcessModels: [],
      itemDetailModels: [],
      isShowTabs: false,
      currentIndex: -1,
      deleteProcess: [], // 删除的工序
      warehouseList: [],
      selList: '', //选中行的列表
      batchDocDate: null, //批量单据日期
      batchEndTime: null, //预计完工日期
      DpId: null,
      batchShowEndTime: null,
      MarkAccount: [],
      initMarkAccount: [],
      initMarkTotal: 0,
      listMarkTotal: 0,
      pageMarkParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      MarkHead: [
        { Value: 'TrademarkNo', Name: '商标编码', Width: '150' },
        { Value: 'TrademarkName', Name: '商标名称', Width: '150' }
      ]
    }
  },
  props: {
    Status: {
      type: Number,
      default: 0
    },
    QuickProcess: {
      type: Boolean,
      default: false
    },
    scQuantity: {
      type: Number,
      default: 1
    },
    AssemblingBoms: {
      type: Object,
      default: () => {}
    },
    editAssembling: {
      type: Array,
      default: () => []
    },
    OrderProductNo: {
      type: String,
      default: ''
    },
    productLists: {
      type: Array,
      default: () => []
    },
    editType: {
      type: Number,
      default: 0
    },
    tradeUnitListProp: {
      type: Array,
      default: () => []
    },
    propertyListProp: {
      type: Array,
      default: () => []
    },
    equipmentListProp: {
      type: Array,
      default: () => []
    },
    warehouseProp: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: () => true
    },
    machiningStageId: {
      type: Number,
      default: () => null
    },
    isCheckCapacity: {
      type: Boolean,
      default: () => false
    },
    stageName: {
      type: String,
      default: ''
    },
    mstage: {
      type: Object,
      default: () => {}
    },
    initProductProp: {
      type: Object,
      default: () => {}
    },
    teProcessProp: {
      type: Array,
      default: () => []
    },
    initTrademarkProp: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    // this.pdApi
    //   .list({
    //     ProcessStages: [2, 1, 0],
    //     Status: 1,
    //     pageSize: this.pageParams.pageSize,
    //     pageIndex: this.pageParams.pageIndex
    //   })
    //   .then(res => {
    //     if (res.Code === 0) {
    //       // console.log("productApi res.Data", res.Data);
    //       this.DAccount = res.Data
    //       this.initDAccount = res.Data
    //       this.listTotal = res.Count
    //       this.initTotal = res.Count
    //     }
    //   })
    // this.teProcessApi.list({}).then(res => {
    //   if (res.Code === 0) {
    //     this.teProcessList = res.Data
    //   }
    // })
    // this.tradeUnitApi.list({ TradeUnitTypes: [1, 3], Status: 1 }).then((res) => {
    //   if (res.Code === 0) {
    //     this.tradeUnitList = res.Data;
    //   }
    // });
    // this.propertyApi.list({Status: 1}).then(res => {
    //   if(res.Code === 0){
    //     this.propertyList = res.Data;
    //   }
    // })
  },
  mounted() {
    this.initProp()
    if (this.isEdit) {
      this.getEditAssembling()
    } else {
      this.getAssemblingBoms()
    }
    console.log(this.stageName, 'stageName')
    console.log(this.mstage, 'mstage')
  },
  watch: {
    initTrademarkProp: {
      deep: true,
      immediate: true,
      handler(val) {
        this.initMarkAccount = val.Data
        this.MarkAccount = val.Data
        this.initMarkTotal = val.Count
        this.listMarkTotal = val.Count
      }
    },
    teProcessProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 'teProcessProp')
        this.teProcessList = val
      }
    },
    initProductProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 'initProductData2')
        this.DAccount = val.Data
        this.initDAccount = val.Data
        this.initTotal = val.Count
        this.listTotal = val.Count
      }
    },
    scQuantity(val) {
      console.log('循环的scQuantity更新了', val)

      this.DetailModels.forEach(item => {
        item.DetailModels.forEach(item => {
          if (item.qua) {
            if (this.editType === 1 && item.T !== 0) {
              item.T = 1
            }
            item.qua = Math.ceil(item.Quantity * val)
          }
        })
      })

      this.Products.forEach(item => {
        if (item.qua) {
          if (this.editType === 1 && item.T !== 0) {
            item.T = 1
          }
          item.qua = Math.ceil(item.Quantity * val)
        }
      })
    },
    AssemblingBoms(val) {
      console.log('循环的AssemblingBoms更新了', val)

      let { Bom, DetailModels, ProcessModels } = val

      Bom.forEach(item => {
        item.currentProductNature = item.ProductNature
        if (item.ProductNature === 2) {
          item.ProductNature = 0
        }
        this.$set(item, 'T', 0)
        this.$set(item, 'WorkDocId', 0)
        this.$set(item, 'WorkDocProductId', 0)
        this.$set(item, 'WorkDocNo', '')
        this.$set(item, 'StockQuantity', item.StockQuantity)
        this.$set(item, 'ExistQuantity', item.ExistQuantity)
        this.$set(item, 'SchedulingType', 0)
        this.$set(item, 'DpId', item.DpId ?? null)
        this.$set(item, 'MaintenanceId', item.MaintenanceId ?? null)
        this.$set(item, 'ProductionType', item.ProductNature)
        this.$set(item, 'ProductionDpId', item.DefaultSupplier)
        this.$set(item, 'DocDate', this.$commonJs.getToday())
        this.$set(item, 'EndTime', this.$commonJs.getNowDatetimeString())
        this.$set(item, 'Remark', '')
        this.$set(item, 'Pno', item.ProductNo)
        this.$set(item, 'Pname', item.ProductName)
        this.$set(item, 'PickingWarehouseId', item.WarehouseId)
        this.$set(item, 'PickingWarehousePositionId', item.WarehousePositionId)
        this.$set(item, 'BatchNumber', item.BatchNumber)
        this.$set(item, 'BarCode', item.BarCode)

        console.log('item.BarCode1', item.BarCode) // <!-- h -->
      })

      this.Products = Bom

      this.Products.forEach(item => {
        this.$set(item, 'qua', item.Quantity * this.scQuantity)
        //if (item.DpId) {
        this.$set(item, 'showDp', true)
        this.$set(item, 'showMt', false)
        //}
        if (item.MaintenanceId) {
          this.$set(item, 'showDp', false)
          this.$set(item, 'showMt', item.ProductionType == 0)
        }
      })

      DetailModels.forEach((item, i) => {
        item.DetailModels.forEach(v => {
          v.T = 0
          v.WorkDocMaterialId = 0
          v.WorkDocId = 0
          v.Ration = 0
          v.RationUnit = 0
          v.Rate = 0
          v.Loss = 0
          v.rateQua = item.fqua / v.Quantity
          this.$set(v, 'qua', v.Quantity * this.scQuantity)
          v.lastProductId = v.ProductId
          v.currentProductId = v.ProductId
          v.lastProcessStage = v.ProcessStage
          v.currentProcessStage = v.ProcessStage
          v.lastPropertyId = v.PropertyId
          v.currentPropertyId = v.PropertyId
          v.Pno = v.ProductNo
          v.Pname = v.ProductName
          v.OutWarehouseId = v.WarehouseId

          if ((v.MouldId != null) & (v.PropertyName === '注塑') && v.ProduceTypeName === '胶件') {
            this.teMouldBomApi
              .list({
                IsEnable: true,
                MouldId: v.MouldId
              })
              .then(res => {
                if (res.Code === 0) {
                  v.MouldBomNos = res.Data
                }
              })
          }
        })
      })

      this.DetailModels = DetailModels

      ProcessModels.forEach(item => {
        item.T = 0
        item.WorkDocProcessId = 0
        item.WorkDocId = 0
        item.SnType = 0
        item.ConvertRatio = 1
        item.MachineId = 0
        item.Length = 0
        item.Width = 0
        item.Multiple = 0
        item.RatedLoss = 0
        item.LossRate = 0
        item.PlanIn = 0
        ;(item.PlanOut = 0), (item.PlanOutUnit = '')
        item.Requirement = ''
        item.Status = 0
      })

      this.ProcessModels = ProcessModels

      // let arr = [];
      // let _DetailModels = [];
      // let _ProcessModels = [];
      // val.forEach(item => {
      //   let {DetailModels, ProcessModels, ...rest} = item;
      //   let Pname = rest.Pname;
      //   let Pno = rest.Pno;
      //   let ProductId = rest.ProductId;

      //   let child = DetailModels;
      //   let o = {
      //     Pname,
      //     ProductId,
      //     DetailModels: child
      //   }
      //   _DetailModels.push(o)
      //   arr.push(rest)

      //   let copyProcessModels = JSON.parse(JSON.stringify(ProcessModels))

      //    copyProcessModels.forEach(item => {
      //       item.T = 0;
      //       item.WorkDocProcessId = 0;
      //       item.WorkDocId = 0;
      //       item.SnType = 0;
      //       item.ConvertRatio = 1;
      //       item.MachineId = 0;
      //       item.Length = 0;
      //       item.Width = 0;
      //       item.Multiple = 0;
      //       item.RatedLoss = 0;
      //       item.LossRate = 0;
      //       item.PlanIn = 0;
      //       item.PlanOut = 0,
      //       item.PlanOutUnit = "";
      //       item.Requirement = "";
      //       item.Status = 0;
      //   })

      //   let processO = {
      //     Pno,
      //     Pname,
      //     ProductId,
      //     ProgrammeName: ProcessModels.length !== 0 ? ProcessModels[0].ProgrammeName : "",
      //   ProgrammeId: ProcessModels.length !== 0 ? ProcessModels[0].ProgrammeId : 0,
      //     Processes: copyProcessModels
      //   }
      //   _ProcessModels.push(processO)
      // })

      // this.DetailModels = _DetailModels;
      // this.ProcessModels = _ProcessModels;

      // arr.forEach(item => {
      //   this.$set(item, 'T', 0);
      //   this.$set(item, 'WorkDocId', 0);
      //   this.$set(item, 'WorkDocProductId', 0);
      //   this.$set(item, 'WorkDocNo', "");
      //   this.$set(item, 'StockQuantity', 0);
      //   this.$set(item, 'SchedulingType', null);
      //   this.$set(item, 'DpId', null);
      //   this.$set(item, 'MaintenanceId', null);
      //   this.$set(item, 'ProductionType', item.ProductNature);
      //   this.$set(item, 'ProductionDpId', item.DefaultSupplier);
      //   this.$set(item, 'DocDate', this.$commonJs.getToday());
      //   this.$set(item, 'EndTime', this.$commonJs.getToday());
      //   this.$set(item, 'Remark', "");
      // })

      //  arr.forEach(item => {
      //   this.$set(item, 'qua', item.Quantity * this.scQuantity);
      // })

      // this.Products = arr
    },

    editAssembling(val) {
      console.log('循环的editAssembling更新了', val)

      let _ProductModels = []
      let _ProcessModels = []
      let _MaterialModels = []

      val.forEach(item => {
        let { MaterialModels, ProcessModels, ProductModels, ...rest } = item

        MaterialModels.forEach(item => {
          item.currentProductId = item.ProductId
          item.lastProcessStage = item.ProcessStage
          item.currentProcessStage = item.ProcessStage
          item.lastPropertyId = item.PropertyId
          item.currentPropertyId = item.PropertyId
          item.OutWarehouseId = item.WarehouseId

          item.PdUnitName = item.UnitName
          item.PdUnitId = item.QuantityUnit
          item.Pname = item.ProductName
          item.Pno = item.ProductNo
          item.ChildBomNo = item.ChildGroupNo !== '' && item.ChildGroupNo != null ? item.ChildGroupNo : item.ChildBomNo
          this.$set(item, 'qua', item.Quantity * this.scQuantity)

          if ((item.MouldId != null) & (item.PropertyName === '注塑') && item.ProduceTypeName === '胶件') {
            this.teMouldBomApi
              .list({
                IsEnable: true,
                MouldId: item.MouldId
              })
              .then(res => {
                if (res.Code === 0) {
                  item.MouldBomNos = res.Data
                }
              })
          }
        })

        ProductModels.forEach(item => {
          item.OrderProductNo = this.OrderProductNo
          item.Bomno = item.ChildGroupNo !== '' && item.ChildGroupNo != null ? item.ChildGroupNo : item.Bomno

          item.Pname = item.ProductName
          item.Pno = item.ProductNo

          item.currentProductNature = item.ProductNature

          for (let i in rest) {
            if (!item.hasOwnProperty(i)) {
              this.$set(item, i, rest[i])
            }
          }

          let o1 = {
            pid: item.ProductId,
            Pname: item.ProductName,
            fqua: item.Quantity,
            DetailModels: MaterialModels
          }

          _MaterialModels.push(o1)

          let o = {
            Pname: item.ProductName,
            Pno: item.ProductNo,
            pid: item.ProductId,
            ProgrammeName: ProcessModels[0]?.ProgrammeName ?? '',
            Processes: ProcessModels
          }

          _ProcessModels.push(o)
        })

        _ProductModels.push(...ProductModels)
      })

      _ProductModels.forEach(item => {
        this.$set(item, 'qua', item.Quantity * this.scQuantity)
        //if (item.DpId) {
        this.$set(item, 'showDp', true)
        this.$set(item, 'showMt', false)
        //}
        if (item.MaintenanceId) {
          this.$set(item, 'showDp', false)
          this.$set(item, 'showMt', item.ProductionType == 0)
        }
      })

      _MaterialModels.forEach(item => {
        item.DetailModels.forEach(v => {
          v.rateQua = item.fqua / v.Quantity
        })
      })

      this.changeT(_ProductModels)
      this.changeT(_ProcessModels, 2)
      this.changeT(_MaterialModels, 1)

      this.Products = _ProductModels
      this.ProcessModels = _ProcessModels
      this.DetailModels = _MaterialModels
    },
    productLists(val) {
      let data = val.filter(item => {
        return item.ProcessStage !== 3 && item.ProcessStage !== 4
      })
      this.DAccount = data
      this.initDAccount = data
      this.listTotal = data.length
      this.initTotal = data.length
    },
    tradeUnitListProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log('循环的tradeUnitListProp更新了', val)
        this.tradeUnitList = val
      }
    },
    propertyListProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log('循环的propertyListProp更新了', val)
        this.propertyList = val
      }
    },
    equipmentListProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log('循环的equipmentListProp更新了', val)
        this.equipmentList = val
      }
    },
    warehouseProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log('循环的scQuantity更新了', val)
        this.warehouseList = val
      }
    }
  },
  methods: {
    onMarkClear(row) {
      row.TrademarkId = null
      row.TrademarkName = ''
      row.TrademarkNo = ''
    },
    onMarkSelect(val, row) {
      console.log(val, row, 'onMarkSelect')
      if (val) {
        row.TrademarkId = val.TrademarkId
        row.TrademarkName = val.TrademarkName
        row.TrademarkNo = val.TrademarkNo
        if (val.TrademarkPhoto) {
          var photos = val.TrademarkPhoto.split(',')
          if (!row.PdImgs) {
            row.PdImgs = []
          }
          photos.forEach(item => {
            console.log(item, 'photos')
            row.PdImgs.push({ ImgUrl: item, T: 0, WorkDocProductId: 0, ProductImgId: 0, ImgType: 2 })
          })
        }
      }
    },
    resetMarkFun(row) {
      this.pageMarkParams.pageIndex = 1
      this.MarkAccount = this.initMarkAccount
      this.listMarkTotal = this.initMarkTotal

      let param = { pageIndex: 1, pageSize: 7, Status: 1 }

      this.trademarkApi.list(param).then(res => {
        if (res.Code == 0) {
          this.MarkAccount = res.Data
          this.listMarkTotal = res.Count
        }
      })
    },
    currentMarkPage({ val, text1 }, row) {
      console.log(val, text1, row)
      this.pageMarkParams.pageIndex = val

      let param = { pageIndex: val, pageSize: 7, Status: 1, TrademarkName: text1 }

      this.trademarkApi.list(param).then(res => {
        if (res.Code == 0) {
          this.MarkAccount = res.Data
          this.listMarkTotal = res.Count
        }
      })
    },
    inputMarkText(text) {
      this.trademarkApi
        .list({
          PageIndex: 1,
          PageSize: 7,
          TrademarkName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.MarkAccount = res.Data
            this.listMarkTotal = res.Count
          }
        })
    },
    changeDp(val) {
      this.Products = this.Products.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.ProductId === obj1.ProductId)
        if (duplicateObj) {
          obj1.DpId = this.DpId
        }
        return obj1
      })
      this.DpId = null
      this.$refs.dpSelect.value = null
      this.$refs.dpSelect.value1 = null
      this.$refs.dpSelect.init()
    },
    img_saved(data, removeData, row) {
      console.log(data, removeData, row, 'img_saved')
      if (data) {
        console.log(data, removeData, row, 'img_saved2')
        var imgs = []
        data.forEach(item => {
          imgs.push({ WorkDocProductId: row.WorkDocProductId, ImgUrl: item.url2, T: item.T, ProductImgId: item.ProductImgId, ImgType: item.ImgType })
        })
        if (removeData.length > 0) {
          removeData.forEach(item => {
            imgs.push({ WorkDocProductId: row.WorkDocProductId, ImgUrl: item.url2, T: 2, ProductImgId: item.ProductImgId, ImgType: item.ImgType })
          })
        }
        row.PdImgs = imgs
        this.$set(row, 'PdImgs', row.PdImgs)
        this.$set(this.Products, row.index, row)
        console.log(row, this.Products, 'row')
      }
    },
    uploadImg(row) {
      console.log(row, this.Products, 'row')
      if (row.WorkDocProductId > 0) {
        this.$refs.bomPdImgDialog.openEdit(row)
      } else {
        this.$refs.bomPdImgDialog.openCreate(row)
      }
    },
    changeEquipment(row, val) {
      console.log(val, row, 'changeEquipment')
      this.getCapacity(val, row)
    },
    getCapacity(val, row) {
      this.equipmentApi.checkCapacity({ EquipmentId: val }).then(res => {
        if (res.Code === 0) {
          var obj = res.Data
          console.log(obj, row, 'obj')
          var hours = 0
          if (row.qua) {
            if (!obj.info.Cycle) {
              this.$message.warning('该设备未设置成品周期')
              return false
            }

            hours = Math.ceil(row.qua / obj.info.CycleOutPut)
            console.log(hours, obj.info.CycleOutPut, 'hours3')
          }
          console.log(hours, 'hours')
          if (obj.workdoc) {
            if (obj.workdoc.EndTime) {
              var endtime = new Date(obj.workdoc.EndTime)
              var newEndTime = new Date(endtime.getTime() + hours * 60 * 60 * 1000)
              var et = new Date(row.EndTime)
              if (newEndTime.getTime() > et.getTime()) {
                this.$confirm('完工时间比预设完工时间久, 是否替换预设完工时间?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                  .then(() => {
                    row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
                  })
                  .catch(() => {})
              }
            }
          } else {
            var endtime = new Date()
            var newEndTime = new Date(endtime.getTime() + hours * 60 * 60 * 1000)
            var et = new Date(row.EndTime)
            if (newEndTime.getTime() > et.getTime()) {
              this.$confirm('完工时间比预设完工时间久, 是否替换预设完工时间?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
                })
                .catch(() => {})
            }
          }
        }
      })
    },
    initProp() {
      // this.getTradeUnitList()
      // this.getwarehouseList()
      // this.getequipmentList()
      // this.getpropertyList()
    },
    getEditAssembling() {
      let _ProductModels = []
      let _ProcessModels = []
      let _MaterialModels = []

      // console.log("🚀 ~ getEditAssembling ~ this.editAssembling:", this.editAssembling)
      // this.editAssembling = this.dataFilter(this.editAssembling,this.machiningStageId)
      var editAssembling_for = this.dataFilter(this.editAssembling, this.machiningStageId)
      console.log('🚀 ~ getEditAssembling ~ editAssembling_for:', this.machiningStageId, editAssembling_for) // <!-- h -->
      if (editAssembling_for.length > 0) {
        this.workdocApi.getClothStage({ Stage: this.machiningStageId, OrderProductId: editAssembling_for[0].OrderProductId }).then(res => {
          if (res.Code === 0) {
            this.batchShowEndTime = res.Data.EndTime
          }
        })
      }
      editAssembling_for.forEach(item => {
        const o = { Status: 1, WarehouseId: item.PickingWarehouseId }
        this.warehousePositionApi.list(o).then(res => {
          this.warehousePositionList = res.Data
        })

        let { MaterialModels, ProcessModels, ProductModels, ...rest } = item
        // console.log("🚀 ~ editAssembling_for.forEach ~ ProductModels:", ProductModels)

        MaterialModels.forEach(item => {
          item.currentProductId = item.ProductId
          item.lastProcessStage = item.ProcessStage
          item.currentProcessStage = item.ProcessStage
          item.lastPropertyId = item.PropertyId
          item.currentPropertyId = item.PropertyId

          item.PdUnitName = item.UnitName
          item.PdUnitId = item.QuantityUnit
          item.Pname = item.ProductName
          item.Pno = item.ProductNo
          item.ChildBomNo = item.ChildGroupNo !== '' && item.ChildGroupNo != null ? item.ChildGroupNo : item.ChildBomNo
          this.$set(item, 'qua', item.Quantity * this.scQuantity)

          if ((item.MouldId != null) & (item.PropertyName === '注塑') && item.ProduceTypeName === '胶件') {
            this.teMouldBomApi
              .list({
                IsEnable: true,
                MouldId: item.MouldId
              })
              .then(res => {
                if (res.Code === 0) {
                  item.MouldBomNos = res.Data
                }
              })
          }
        })

        ProductModels.forEach(item => {
          console.log(item, 'getEditAssembling')
          item.OrderProductNo = this.OrderProductNo
          item.Bomno = item.ChildGroupNo !== '' && item.ChildGroupNo != null ? item.ChildGroupNo : item.Bomno

          item.Pname = item.ProductName
          item.Pno = item.ProductNo

          item.currentProductNature = item.ProductNature

          for (let i in rest) {
            if (!item.hasOwnProperty(i)) {
              this.$set(item, i, rest[i])
            }
          }

          let o1 = {
            pid: item.ProductId,
            Pname: item.ProductName,
            fqua: item.Quantity,
            DetailModels: MaterialModels
          }

          _MaterialModels.push(o1)

          let o = {
            Pname: item.ProductName,
            Pno: item.ProductNo,
            pid: item.ProductId,
            ProgrammeName: ProcessModels[0]?.ProgrammeName ?? '',
            Processes: ProcessModels
          }

          _ProcessModels.push(o)
        })

        _ProductModels.push(...ProductModels)
      })

      _ProductModels.forEach(item => {
        this.$set(item, 'qua', item.Quantity * this.scQuantity)
        //if (item.DpId) {
        this.$set(item, 'showDp', true)
        this.$set(item, 'showMt', false)
        //}
        if (item.MaintenanceId) {
          this.$set(item, 'showDp', false)
          this.$set(item, 'showMt', item.ProductionType == 0)
        }
      })

      _MaterialModels.forEach(item => {
        item.DetailModels.forEach(v => {
          v.rateQua = item.fqua / v.Quantity
        })
      })

      this.changeT(_ProductModels)
      this.changeT(_ProcessModels, 2)
      this.changeT(_MaterialModels, 1)

      this.Products = _ProductModels //ini <!-- h -->
      //console.log("🚀 ~ getEditAssembling ~ this.Products:", this.Products) //ini <!-- h -->
      this.ProcessModels = _ProcessModels
      this.DetailModels = _MaterialModels
    },
    getAssemblingBoms() {
      let { Bom, DetailModels, ProcessModels } = this.AssemblingBoms

      Bom.forEach(item => {
        console.log(item, 'getAssemblingBoms')
        item.currentProductNature = item.ProductNature
        if (item.ProductNature === 2) {
          item.ProductNature = 0
        }
        this.$set(item, 'T', 0)
        this.$set(item, 'WorkDocId', 0)
        this.$set(item, 'WorkDocProductId', 0)
        this.$set(item, 'WorkDocNo', '')
        this.$set(item, 'StockQuantity', item.StockQuantity)
        this.$set(item, 'ExistQuantity', item.ExistQuantity)
        this.$set(item, 'SchedulingType', 0)
        this.$set(item, 'DpId', item.DpId ?? null)
        this.$set(item, 'MaintenanceId', item.MaintenanceId ?? null)
        this.$set(item, 'ProductionType', item.ProductNature)
        this.$set(item, 'ProductionDpId', item.DefaultSupplier)
        this.$set(item, 'DocDate', this.$commonJs.getToday())
        this.$set(item, 'EndTime', this.$commonJs.getNowDatetimeString())
        this.$set(item, 'Remark', '')
        this.$set(item, 'Pno', item.ProductNo)
        this.$set(item, 'Pname', item.ProductName)
        this.$set(item, 'PickingWarehouseId', item.WarehouseId)
        this.$set(item, 'PickingWarehousePositionId', item.WarehousePositionId)
        this.$set(item, 'BatchNumber', item.BatchNumber)
        this.$set(item, 'BarCode', item.BarCode)
        this.$set(item, 'PdImgs', item.PdImgs)

        console.log('item.BarCode2', item.BarCode) // <!-- h -->
      })

      this.Products = Bom

      this.Products.forEach(item => {
        this.$set(item, 'qua', item.Quantity * this.scQuantity)
        //if (item.DpId) {
        this.$set(item, 'showDp', true)
        this.$set(item, 'showMt', false)
        //}
        if (item.MaintenanceId) {
          this.$set(item, 'showDp', false)
          this.$set(item, 'showMt', item.ProductionType == 0)
        }
      })

      DetailModels.forEach((item, i) => {
        item.DetailModels.forEach(v => {
          v.T = 0
          v.WorkDocMaterialId = 0
          v.WorkDocId = 0
          v.Ration = 0
          v.RationUnit = 0
          v.Rate = 0
          v.Loss = 0
          v.rateQua = item.fqua / v.Quantity
          this.$set(v, 'qua', v.Quantity * this.scQuantity)
          v.lastProductId = v.ProductId
          v.currentProductId = v.ProductId
          v.lastProcessStage = v.ProcessStage
          v.currentProcessStage = v.ProcessStage
          v.lastPropertyId = v.PropertyId
          v.currentPropertyId = v.PropertyId
          v.Pno = v.ProductNo
          v.Pname = v.ProductName
          v.OutWarehouseId = v.WarehouseId
          console.log(v, 'getAssemblingBoms,DetailModels')

          if ((v.MouldId != null) & (v.PropertyName === '注塑') && v.ProduceTypeName === '胶件') {
            this.teMouldBomApi
              .list({
                IsEnable: true,
                MouldId: v.MouldId
              })
              .then(res => {
                if (res.Code === 0) {
                  v.MouldBomNos = res.Data
                }
              })
          }
        })
      })

      this.DetailModels = DetailModels

      ProcessModels.forEach(item => {
        item.T = 0
        item.WorkDocProcessId = 0
        item.WorkDocId = 0
        item.SnType = 0
        item.ConvertRatio = 1
        item.MachineId = 0
        item.Length = 0
        item.Width = 0
        item.Multiple = 0
        item.RatedLoss = 0
        item.LossRate = 0
        item.PlanIn = 0
        ;(item.PlanOut = 0), (item.PlanOutUnit = '')
        item.Requirement = ''
        item.Status = 0
      })

      this.ProcessModels = ProcessModels
    },
    getTradeUnitList() {
      this.tradeUnitApi.list({ TradeUnitTypes: [3], Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data
        }
      })
    },
    getwarehouseList() {
      this.warehouseApi.list({}).then(res => {
        if (res.Code === 0) {
          this.warehouseList = res.Data
        }
      })
    },
    getequipmentList() {
      this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
        if (res.Code === 0) {
          this.equipmentList = res.Data
          console.log(this.equipmentList, 'eq')
        }
      })
    },
    getpropertyList() {
      this.propertyApi.list({ Statuse: 1 }).then(res => {
        if (res.Code === 0) {
          this.propertyList = res.Data
          console.log(this.propertyList, 'eq')
        }
      })
    },
    dataFilter(data, stage) {
      return data.filter(item => {
        return item.Stage === stage
      })
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    jsonCopy(data) {
      return JSON.parse(JSON.stringify(data))
    },
    changePQuantity(val, row) {
      let { index } = row
      let detailModels = this.DetailModels[index].DetailModels
      console.log('detailModels', detailModels)
      let Quantity = localStorage.getItem('Quantity') ?? 0
      if (row.T !== 0) {
        row.T = 1
      }
      if (detailModels.length !== 0) {
        detailModels.forEach(item => {
          if (item.T !== 0) {
            item.T = 1
          }
          item.qua = (val / item.rateQua).toFixed(Quantity)
        })

        // this.$emit("ChangeListArray_for", this.jsonCopy(detailModels),this.machiningStageId);
      }
      if (row.MaintenanceId) {
        this.getCapacity(row.MaintenanceId, row)
      }
    },
    // 附件删除
    delPro(row, i) {
      this.$confirm('确定删除这条记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        let { index } = row

        if (row.T !== 0) {
          let delProduct = this.Products[index]
          delProduct.T = 2
          this.deleteProducts.push(delProduct)
        }

        console.log('this.DetailModels', this.DetailModels)

        let detailBom = this.DetailModels.filter(item => {
          return item.pid === row.ProductId
        })[0]

        detailBom.DetailModels.forEach(item => {
          item.delete = true
          if (item.T !== 0) {
            item.T = 2
            this.deleteDetailModels.push(detailBom)
          }
        })
        console.log('this.deleteDetailModels', this.deleteDetailModels)

        let dindex = this.DetailModels.findIndex(item => {
          return item.pid === detailBom.pid
        })

        let dindex1 = this.ProcessModels.findIndex(item => {
          return item.pid === row.ProductId
        })
        let ProcessModelsObj = this.ProcessModels[dindex1]
        if (ProcessModelsObj.T !== 0) {
          ProcessModelsObj.T = 2
          this.deleteProcessModels.push(ProcessModelsObj)
        }

        this.$emit('ChangeListArray', detailBom.DetailModels)

        this.Products.splice(index, 1)
        this.DetailModels.splice(dindex, 1)
        this.ProcessModels.splice(dindex1, 1)

        this.isShowTabs = false
      })
    },
    // 表格行点击，根据存货，显示对应的数据到工艺和产品子件
    rowClick(row) {
      let { index } = row
      console.log('index', index)

      this.currentIndex = index

      let _itemProcessModels = []
      let _itemDetailModels = []

      _itemProcessModels.push(this.ProcessModels[index])
      _itemDetailModels.push(this.DetailModels[index])

      this.itemProcessModels = _itemProcessModels
      this.itemDetailModels = _itemDetailModels

      console.log('this.itemProcessModels', this.itemProcessModels)
      console.log('this.itemDetailModels', this.itemDetailModels)
      this.isShowTabs = true
    },
    setList(data, dataProductId = 0) {
      console.log('setList') // <!-- h -->
      if (this.Products.length !== 0) {
        if (data.delete) {
          // 查找对应父件的index，进行删除
          let index = this.Products.findIndex(item => {
            return data.ChildBomNo === item.Bomno
          })
          if (index === -1) {
            return
          }
          console.log('index', index)

          let id = this.Products[index].ProductId
          if (dataProductId != 0) {
            id = dataProductId
          }
          console.log('this.Products[index]', this.Products[index])

          console.log('id', id)

          if (this.Products[index].T !== 0) {
            let delProduct = this.Products[index]
            delProduct.T = 2
            this.deleteProducts.push(delProduct)
          }

          console.log('this.DetailModels', this.DetailModels)

          let detailBom = this.DetailModels.filter(item => {
            return item.pid === id
          })[0]

          detailBom.DetailModels.forEach(item => {
            item.delete = true
            if (item.T !== 0) {
              item.T = 2
              this.deleteDetailModels.push(detailBom)
            }
          })

          let dindex = this.DetailModels.findIndex(item => {
            return item.pid === detailBom.pid
          })

          let dindex1 = this.ProcessModels.findIndex(item => {
            return item.pid === id
          })
          let ProcessModelsObj = this.ProcessModels[dindex1]
          if (ProcessModelsObj.T !== 0) {
            ProcessModelsObj.T = 2
            this.deleteProcessModels.push(ProcessModelsObj)
          }

          this.$emit('ChangeListArray', detailBom.DetailModels)

          this.Products.splice(index, 1)
          this.DetailModels.splice(dindex, 1)
          this.ProcessModels.splice(dindex1, 1)
        } else if (data.add && data.delete == null) {
          if (!data.isAddList) {
            data.Bomno = data.ChildBomNo
            console.log('触发1')
            this.$set(data, 'T', 0)
            this.$set(data, 'WorkDocId', 0)
            this.$set(data, 'WorkDocProductId', 0)
            this.$set(data, 'WorkDocNo', '')
            this.$set(data, 'StockQuantity', data.StockQuantity)
            this.$set(data, 'ExistQuantity', data.ExistQuantity)
            this.$set(data, 'SchedulingType', 0)
            this.$set(data, 'DpId', null)
            this.$set(data, 'MaintenanceId', null)
            this.$set(data, 'ProductionType', data.ProductNature)
            this.$set(data, 'ProductionDpId', data.DefaultSupplier)
            this.$set(data, 'DocDate', this.$commonJs.getToday())
            this.$set(data, 'EndTime', this.$commonJs.getNowDatetimeString())
            this.$set(data, 'Remark', '')
            this.$set(data, 'Pno', data.ProductNo)
            this.$set(data, 'Pname', data.ProductName)
            this.$set(item, 'PickingWarehouseId', item.WarehouseId)
            this.$set(item, 'PickingWarehousePositionId', item.WarehousePositionId)
            this.$set(item, 'WarehousePositionId', item.WarehousePositionId)
            this.$set(item, 'BatchNumber', item.BatchNumber)
            this.$set(item, 'BarCode', item.BarCode)
            this.$set(item, 'PdImgs', item.PdImgs)

            console.log('item.BarCode3', item.BarCode) // <!-- h -->

            this.Products.push(data)
            let o = {
              Pname: data.ProductName,
              pid: data.ProductId,
              fqua: data.Quantity,
              DetailModels: []
            }
            this.DetailModels.push(o)

            let o1 = {
              T: 0,
              WorkDocProcessId: 0,
              WorkDocId: 0,
              SnType: 0,
              ConvertRatio: 1,
              MachineId: 0,
              Length: 0,
              Width: 0,
              Multiple: 0,
              RatedLoss: 0,
              LossRate: 0,
              PlanIn: 0,
              PlanOut: 0,
              PlanOutUnit: '',
              Requirement: '',
              Status: 0,
              Pname: data.ProductName,
              Pno: data.ProductNo,
              pid: data.ProductId,
              Processes: []
            }
            this.ProcessModels.push(o1)
          } else {
            console.log('触发2', data)
            let { ChildBomNo } = data
            let bom = null
            let bom1 = this.Products.filter(item => {
              return item.Bomno === ChildBomNo
            })
            if (bom1.length === 0) {
              return
            }
            bom = bom1[0]
            console.log('bom', bom)
            bom.PdImgs = data.PdImgs
            bom.Pname = data.ProductName
            bom.Pno = data.ProductNo
            bom.ProductSpec = data.ProductSpec
            bom.ProcessStage = data.ProcessStage
            bom.ProduceTypeName = data.ProduceTypeName
            bom.ProductId = data.ProductId
            bom.Colors = data.Colors
            bom.PdUnitName = data.PdUnitName
            bom.PdUnitId = data.PdUnitId
            bom.UseProcess = data.UseProcess
            bom.UseColor = data.UseColor

            bom.Mould = data.Mould
            bom.MouldId = data.MouldId
            bom.MouldName = data.MouldName

            bom.DefaultSupplier = data.DefaultSupplier
            bom.ProductNature = data.ProductNature

            bom.ColorId = data.ColorId
            bom.PropertyId = data.PropertyId
            bom.ColorName = data.ColorName
            bom.StockQuantity = data.StockQuantity
            bom.ExistQuantity = data.ExistQuantity
            bom.qua = data.qua

            // 找出父件对应的子件
            let childBom = this.DetailModels.filter(item => {
              return item.pid === bom.ProductId
            })

            if (childBom.length !== 0) {
              childBom[0].DetailModels.forEach(item => {
                item.qua = bom.qua / item.rateQua
              })

              this.$emit('ChangeListArray', childBom[0].DetailModels)
            }
          }
        } else {
          console.log('触发4', data)
          let { ChildBomNo } = data
          let bom = null
          let bom1 = this.Products.filter(item => {
            return item.Bomno === ChildBomNo
          })
          if (bom1.length === 0) {
            return
          }
          bom = bom1[0]
          console.log('bom', bom)
          bom.PdImgs = data.PdImgs
          bom.Pname = data.ProductName
          bom.Pno = data.ProductNo
          bom.ProductSpec = data.ProductSpec
          bom.ProcessStage = data.ProcessStage
          bom.ProduceTypeName = data.ProduceTypeName
          bom.ProductId = data.ProductId
          bom.Colors = data.Colors
          bom.PdUnitName = data.PdUnitName
          bom.PdUnitId = data.PdUnitId
          bom.UseProcess = data.UseProcess
          bom.UseColor = data.UseColor
          bom.T = data.T

          bom.Mould = data.Mould
          bom.MouldId = data.MouldId
          bom.MouldName = data.MouldName
          bom.StockQuantity = data.StockQuantity
          bom.ExistQuantity = data.ExistQuantity

          bom.DefaultSupplier = data.DefaultSupplier
          bom.ProductNature = data.ProductNature

          bom.ColorId = data.ColorId
          bom.PropertyId = data.PropertyId
          bom.ColorName = data.ColorName
          bom.qua = data.qua

          // 找出父件对应的子件
          let childBom = this.DetailModels.filter(item => {
            return item.pid === bom.ProductId
          })[0]

          childBom.DetailModels.forEach(item => {
            item.qua = bom.qua / item.rateQua
            item.T = data.T
          })

          this.$emit('ChangeListArray', childBom.DetailModels)
        }
      } else {
        data.Bomno = data.ChildBomNo
        console.log('触发5')
        this.$set(data, 'T', 0)
        this.$set(data, 'WorkDocId', 0)
        this.$set(data, 'WorkDocProductId', 0)
        this.$set(data, 'WorkDocNo', '')
        this.$set(data, 'StockQuantity', data.StockQuantity)
        this.$set(data, 'ExistQuantity', data.ExistQuantity)
        this.$set(data, 'SchedulingType', 0)
        this.$set(data, 'DpId', null)
        this.$set(data, 'MaintenanceId', null)
        this.$set(data, 'ProductionType', data.ProductNature)
        this.$set(data, 'ProductionDpId', data.DefaultSupplier)
        this.$set(data, 'DocDate', this.$commonJs.getToday())
        this.$set(data, 'EndTime', this.$commonJs.getNowDatetimeString())
        this.$set(data, 'Remark', '')
        this.$set(data, 'Pno', data.ProductNo)
        this.$set(data, 'Pname', data.ProductName)
        this.$set(item, 'PickingWarehouseId', item.WarehouseId)
        this.$set(item, 'PickingWarehousePositionId', item.WarehousePositionId)
        this.$set(item, 'BatchNumber', item.BatchNumber)
        this.$set(item, 'BarCode', item.BarCode)
        this.$set(item, 'PdImgs', item.PdImgs)

        console.log('item.BarCode4', item.BarCode) // <!-- h -->

        this.Products.push(data)

        let o = {
          Pname: data.ProductName,
          pid: data.ProductId,
          fqua: data.Quantity,
          DetailModels: []
        }
        this.DetailModels.push(o)

        let o1 = {
          T: 0,
          WorkDocProcessId: 0,
          WorkDocId: 0,
          SnType: 0,
          ConvertRatio: 1,
          MachineId: 0,
          Length: 0,
          Width: 0,
          Multiple: 0,
          RatedLoss: 0,
          LossRate: 0,
          PlanIn: 0,
          PlanOut: 0,
          PlanOutUnit: '',
          Requirement: '',
          Status: 0,
          Pname: data.ProductName,
          Pno: data.ProductNo,
          pid: data.ProductId,
          Processes: []
        }
        this.ProcessModels.push(o1)
      }

      this.isShowTabs = false
    },
    changeList(row, dataProductId = 0, lastProcessStage = -1, lastPropertyId = 0) {
      this.$emit('changeList', row, dataProductId, lastProcessStage, lastPropertyId)
    },
    sumRubbers(data) {
      let arr = []
      let copyData = JSON.parse(JSON.stringify(data))
      copyData.forEach(item => {
        let length = arr.length
        // console.log("length", length);
        let bool = true
        for (let i = 0; i < length; ++i) {
          // console.log("item", item);
          // console.log("arr", arr);
          if (item.ProductId === arr[i].ProductId && item.ColorId === arr[i].ColorId) {
            arr[i].Quantity = arr[i].Quantity + item.Quantity
            console.log(`arr[${i}].Quantity`, arr[i].Quantity)
            arr[i].qua = arr[i].qua + item.qua
            console.log(`arr[${i}].qua`, arr[i].qua)
            bool = false
            break
          }
        }
        if (bool) {
          arr.push(item)
          // console.log("arr", arr);
        }
      })

      console.log('sumRubbers arr', arr)

      return arr
    },
    changeT(data, type = 0) {
      if (type === 0) {
        data.forEach(item => {
          item.T = null
        })
      } else if (type === 1) {
        data.forEach(item => {
          item.DetailModels.forEach(v => {
            v.T = null
          })
        })
      } else if (type === 2) {
        data.forEach(item => {
          item.T = null
          item.Processes.forEach(v => {
            v.T = 1
          })
        })
      }
    },
    changeProcessType(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    editT(row) {
      // if(this.editType === 1 && row.T !== 0){
      //   row.T = 1;
      // }
    },
    selectCome(row) {
      if (row.TradeUnitName == null) {
        this.$set(row, 'TradeUnitName', '')
      }
      this.$refs.comeListDialog.open().then(that => {
        that.getData({ TradeUnitType: 3 })
      })
    },
    // delProcess(row, index) {

    //   if(this.ProcessModels[this.currentIndex].ProgrammeId !== 0){
    //     this.$message.error('请先修改方案名称')
    //     return
    //   }

    //   if(row.T !== 0){
    //     row.T = 2;
    //     console.log('row', row)
    //     this.deleteProcess.push(row);
    //   }
    //   this.ProcessModels[this.currentIndex].Processes.splice(index, 1)
    // },
    listDialogSelect(list) {
      let deleteProcessModels = JSON.parse(JSON.stringify(this.programmeCurrentRow))
      console.log('deleteProcessModels', deleteProcessModels)
      if (deleteProcessModels.Processes.length !== 0 && deleteProcessModels.Processes[0].T === 1) {
        deleteProcessModels.Processes.forEach(item => {
          item.T = 2
        })

        this.deleteProcess.push(...deleteProcessModels.Processes)

        console.log('this.deleteProcess', this.deleteProcess)
      }

      list.Processes.forEach(item => {
        item.ProcessType = null
        item.DpId = 0
        item.TradeUnitName = ''
      })

      this.programmeCurrentRow.Processes = list.Processes
      this.programmeCurrentRow.ProgrammeId = list.ProgrammeId
      this.programmeCurrentRow.ProgrammeName = list.ProgrammeName

      let item = this.Products.filter(item => {
        return item.ProductId === this.programmeCurrentRow.pid
      })[0]
      item.ProgrammeId = list.ProgrammeId
      if (item.T !== 0) {
        item.T = 1
      }
      let copyProcessModels = JSON.parse(JSON.stringify(this.ProcessModels))
      this.ProcessModels = []
      this.$nextTick(() => {
        this.ProcessModels = copyProcessModels
        let arr = []
        arr.push(this.ProcessModels[this.currentIndex])
        this.itemProcessModels = arr
      })
    },
    detail_saved(list) {
      this.programmeCurrentRow.Processes = list
    },
    changeProgramme(row, index) {
      this.programmeCurrentRow = row
      this.programmeCurrentIndex = index
      this.$refs.listDialog.open()
    },
    changeProgrammeInfo(row) {
      this.programmeCurrentRow = row
      console.log('this.programmeCurrentRow', this.programmeCurrentRow)
      this.$refs.detailDialog.open().then(that => {
        that.setTableData(row)
      })
    },
    changeProperty(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
      let item = this.propertyList.filter(item => {
        return item.PropertyId === val
      })[0]

      row.PropertyName = item.PropertyName
      row.PropertyId = item.PropertyId

      if (item.PropertyName !== '注塑') {
        row.MouldBomNo = ''
        if (row.add == null) {
          row.add = true
        }
        if (row.isAddList == null) {
          row.isAddList = false
        }
        if (!row.ChildBomNo) {
          row.ChildBomNo = Date.now() + Math.random() * 5 + '-'
        }
        this.changeList(row)
        row.isAddList = true
      }
    },
    changeColor(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
        console.log('row', row)
      }
      let item = row.Colors.filter(item => {
        return item.ColorId === val
      })[0]

      row.ColorName = item.ColorName

      this.$message.info('颜色更改, bom版本可能不一致, 如有需要请手动更改')

      this.changeList(row)
    },
    changeQua(val, row, item) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
      val = parseFloat(val)
      if (!row.Quantity) {
        row.Quantity = val / this.scQuantity
      }
      if (!row.rateQua) {
        let pid = item.pid
        let obj = this.Products.filter(v => {
          return v.ProductId === pid
        })[0]
        row.rateQua = obj.Quantity / row.Quantity
      }
      row.qua = val

      // this.changeList(row);
    },
    onSelectMouldBomNo(e, row) {
      row.MouldBomNo = e.Bomno
      if (row.T !== 0) {
        row.T = 1
      }

      this.changeList(row)
      row.isAddList = true
    },
    onSelect(e, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }

      row.lastProductId = row.currentProductId
      row.currentProductId = e.ProductId

      row.lastProcessStage = row.currentProcessStage
      row.currentProcessStage = e.ProcessStage

      row.ColorId = 0
      row.PropertyId = 0
      this.$set(row, 'Pname', e.ProductName)
      this.$set(row, 'Pno', e.ProductNo)
      row.ProductName = e.ProductName
      row.ProductNo = e.ProductNo
      row.ProductSpec = e.ProductSpec
      row.ProcessStage = e.ProcessStage
      row.ProduceTypeName = e.ProduceTypeName
      row.ProductId = e.ProductId
      row.Colors = e.Colors
      row.PdUnitName = e.PdUnitName
      row.PdUnitId = e.PdUnitId
      row.UseProcess = e.UseProcess
      row.UseColor = e.UseColor

      row.Mould = e.Mould
      row.MouldId = e.MouldId
      row.MouldNo = e.MouldNo
      row.MouldName = e.MouldName

      row.DefaultSupplier = e.DefaultSupplier
      row.ProductNature = e.ProductNature
      row.StockQuantity = e.StockQuantity
      row.ExistQuantity = e.ExistQuantity

      if (row.MouldId != null && row.ProduceTypeName === '胶件') {
        this.teMouldBomApi
          .list({
            IsEnable: true,
            MouldId: e.MouldId
          })
          .then(res => {
            if (res.Code === 0) {
              row.MouldBomNos = res.Data
            }
          })
      }

      // 原有的 原配件，更换配件
      // if(row.add == null && row.ProcessStage === 2 && row.lastProcessStage === 2 ){
      //   this.changeList(row)
      // }else if(row.add == null && row.ProcessStage !== 2  && row.lastProcessStage === 2 ){ // 原有的 原配件，更换非配件
      //   row.delete = true;
      //   this.changeList(row, row.lastProductId,row.lastProcessStage, row.lastPropertyId)
      // }else if(row.add == null && row.ProcessStage === 1&& row.lastProcessStage === 1
      //   && row.lastPropertyId !== 0 && row.lastPropertyId !== 1 && row.PropertyId !== 0 && row.PropertyId !== 1 ){ // 原有的 原特殊，更换特殊
      //     this.changeList(row)
      //   }else if(row.add == null && row.ProcessStage === 2 && row.lastProcessStage === 1 ){ // 原有的 原特殊，更换为配件

      //   }

      if (row.isAddList && row.ProcessStage === 0) {
        row.delete = true
        console.log('删除')
        this.changeList(row, row.lastProductId, row.lastProcessStage, row.lastPropertyId)
      } else if (row.isAddList === false && row.ProcessStage === 0) {
        //
      } else if (row.add == null && row.ProcessStage === 0) {
        row.delete = true
        this.changeList(row, row.lastProductId, row.lastProcessStage, row.lastPropertyId)
      } else {
        this.changeList(row)
      }

      if (row.ProcessStage !== 1) {
        row.isAddList = true
      }
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      this.pdApi
        .list({
          pageIndex: val,
          pageSize: 7,
          ProductName: text1,
          ProcessStages: [2, 1, 0],
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    inputText(text) {
      this.pdApi
        .list({
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          ProcessStages: [2, 1, 0],
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data

            this.listTotal = res.Count
          }
        })
    },
    _getData(params) {
      this.getData(params)
    },
    tabChange(e) {
      if (e.index === '1') {
        this.sumTableData = []
        let arr = []
        this.DetailModels.forEach(item => {
          arr.push(...item.DetailModels)
        })
        this.sumTableData = this.sumRubbers(arr)
      }
    },
    changeSchedulingType(val, row) {
      this.editT(row)
      console.log(val, 'changeSchedulingType')
      if (val === 0) {
        row.DpId = 0
        row.MaintenanceId = null
        row.showDp = true
        row.showMt = false
      } else if (val === 1) {
        row.DpId = 0
        row.MaintenanceId = null
        row.showDp = false
        row.showMt = row.ProductionType == 0
      }
      console.log(row, 'changeSchedulingType2')
    },
    add() {
      let o = {
        OrderProductNo: this.Products[0].OrderProductNo,
        T: 0,
        WorkDocId: 0,
        WorkDocNo: '',
        WorkDocMaterialId: 0,
        Pno: '',
        Pname: '',
        ProductId: 0,
        ImgUrl: '',
        ProductSpec: '',
        PdUnitId: 0,
        PdUnitName: '',
        ColorId: 0,
        ColorName: '',
        Quantity: '',
        ProcessStage: '',
        ProduceTypeName: '',
        StockQuantity: '',
        ExistQuantity: '',
        PickingQuantity: 0,
        ConsumeQuantity: 0,
        PropertyId: 0,
        PropertyName: '',
        MouldBomNo: '',
        MouldBomNos: [],
        add: true,
        isAddList: false, // 是否被添加到下个阶段的父件列表
        Loss: 0,
        Rate: 0,
        Ration: 0,
        RationUnit: 0,
        qua: 0,
        ChildBomNo: Date.now() + Math.random() * 5 + '-'
      }
      console.log('ChildBomNo o', o)
      this.DetailModels[this.currentIndex].DetailModels.push(o)
    },

    // addProcesses(){

    //   if(this.ProcessModels[this.currentIndex].ProgrammeId !== 0){
    //     this.$message.error('请先修改方案名称')
    //     return
    //   }

    //   let o = {
    //     BomType: 0,
    //     DpId: 0,
    //     ProcessId: null,
    //     ProcessName: "",
    //     ProcessType: null,
    //     ProgrammeId: 0,
    //     ProgrammeName: this.ProcessModels[this.currentIndex].ProgrammeName,
    //     T: 0,
    //     TeProductId: 0,
    //     TeProductProcessId: 0,
    //     TebomId: 0,
    //     TespecialBomId: 0,
    //     TradeUnitName: null,
    //     WorkDocId: 0,
    //     WorkDocProcessId: 0,
    //   }
    //   this.ProcessModels[this.currentIndex].Processes.push(o)

    // },
    comeSelect(row) {
      this.currentRow.DpId = row.TradeUnitId
      this.currentRow.TradeUnitName = row.FullName
      if (this.currentRow.T !== 0) {
        this.currentRow.T = 1
      }
    },
    del(item, row, index) {
      this.$confirm('确定删除这条记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        row.delete = true
        if (this.editType === 1 && row.T !== 0) {
          row.T = 2
          let o = {
            pid: item.pid,
            deleteRow: row
          }
          this.deleteLineDetailModels.push(o)
        }
        item.DetailModels.splice(index, 1)
        this.changeList(row)
      })
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    async viewImg(row) {
      console.log('row.ProductId', row.ProductId) // <!-- h -->

      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []

      console.log('ImgUrl', ImgUrl) // <!-- h -->

      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    viewImg2(row) {
      console.log(row, 'img2')
      let imgs = []
      row.PdImgs.forEach(item => {
        imgs.push('/api' + item.ImgUrl)
      })

      console.log(imgs, 'imgs') // <!-- h -->
      if (!imgs || imgs.length == 0) {
        this.$message.warning('未上传设计图！')
        return
      }

      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday()
      var start = ''
      var end = ''
      switch (t) {
        case '今天':
          start = today
          end = today
          break
        case '昨天':
          start = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
          end = start
          break
        case '近3天':
          start = this.$dayjs().subtract(2, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近7天':
          start = this.$dayjs().subtract(6, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近14天':
          start = this.$dayjs().subtract(13, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '本周':
          start = this.$dayjs().startOf('week').format('YYYY-MM-DD')
          end = today
          break
        case '上周':
          var week = this.$dayjs().subtract(1, 'week')
          start = week.startOf('week').format('YYYY-MM-DD')
          end = week.endOf('week').format('YYYY-MM-DD')
          break
        case '本月':
          start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
          end = today
          break
        case '上月':
          var month = this.$dayjs().subtract(1, 'month')
          start = month.startOf('month').format('YYYY-MM-DD')
          end = month.endOf('month').format('YYYY-MM-DD')
          break
        case '本季':
          start = this.$dayjs().startOf('quarter').format('YYYY-MM-DD')
          end = today
          break
        case '上季':
          var quarter = this.$dayjs().subtract(1, 'quarter')
          start = quarter.startOf('quarter').format('YYYY-MM-DD')
          end = quarter.endOf('quarter').format('YYYY-MM-DD')
          break
        case '本年':
          start = this.$dayjs().startOf('year').format('YYYY-MM-DD')
          end = today
          break
        case '上年':
          var year = this.$dayjs().subtract(1, 'year')
          start = year.startOf('year').format('YYYY-MM-DD')
          end = year.endOf('year').format('YYYY-MM-DD')
          break
      }

      return {
        start,
        end
      }
    },
    filterData(data) {
      return data.filter(item => {
        return item.T != null
      })
    },
    sendData() {
      console.log('sendData') // <!-- h -->
      // 检查必填项目
      let keys = [] // 必填的字段
      // SchedulingType DpId MaintenanceId ProductionType  ProductionDpId
      this.Products.forEach(item => {
        if (!this.QuickProcess && item.SchedulingType == null) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: '排产类型'
          })
        } else if (item.ProductionType == 0 && item.SchedulingType === 0 && (item.DpId == null || item.DpId == 0) && !this.QuickProcess) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: '部门'
          })
        } else if (item.SchedulingType === 1 && (item.MaintenanceId == null || item.MaintenanceId == 0) && !this.QuickProcess) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: '设备'
          })
        }
        if (item.ProductionType !== 0 && item.ProductionDpId == null) {
          keys.push({
            name: item.ProductName,
            id: item.ProductId,
            key: '供应商'
          })
        }

        // if(item.PickingWarehouseId == null){
        //   keys.push({
        //     name: item.ProductName,
        //     id: item.ProductId,
        //     key: "领料仓库",
        //   });
        // }
      })

      if (keys.length !== 0) {
        // 构造提示信息
        let arr = Array.from(
          new Set(
            keys.map(item => {
              return item.id
            })
          )
        )

        let msgArr2d = []
        arr.forEach(item => {
          msgArr2d.push(
            keys.filter(v => {
              return v.id === item
            })
          )
        })

        let msgArr = []
        msgArr2d.forEach(item => {
          let name = item[0].name
          let keyStr = item
            .map(v => {
              return v.key
            })
            .join(',')
          msgArr.push(`请填写${this.stageName}工单存货${name}一列中的${keyStr}`)
        })

        let msg = msgArr.join('<br/>')
        console.log(msg, 'msg')
        this.$message({
          type: 'warning',
          message: msg,
          dangerouslyUseHTMLString: true
        })

        return false
      }
      console.log(this.Products, 'senddata')
      let length = this.Products.length
      let arr = []

      for (let i = 0; i < length; ++i) {
        let ProductModels = []
        let ProcessModels = []
        let MaterialModels = []

        // 对默认值进行设置
        let o = {
          T: this.Products[i].T,
          WorkDocProductId: this.Products[i].WorkDocProductId,
          WorkDocId: this.Products[i].WorkDocId,
          ProductId: this.Products[i].ProductId,
          PdUnitId: this.Products[i].PdUnitId,
          ProgrammeId: this.ProcessModels[i]?.ProgrammeId ?? 0,
          ColorId: this.Products[i].ColorId,
          PropertyId: this.Products[i].PropertyId ?? 0,
          Quantity: this.Products[i].qua,
          TeProductId: this.Products[i].TeProductId ?? 0,
          StockQuantity: this.Products[i].StockQuantity,
          ExistQuantity: this.Products[i].ExistQuantity,
          SourceDtsId: 0,
          RpType: this.Products[i].ProcessStage,
          RpRequirement: this.Products[i].RpRequirement ?? '',
          SnType: this.Products[i].SnType ?? 0,
          Loss: this.Products[i].Loss ?? 0,
          Status: this.Products[i].Status ?? 0,
          OrderNo: this.Products[i].OrderProductNo,
          WorkDocNo: this.Products[i].WorkDocNo,
          ChildGroupNo: this.Products[i].add ? this.Products[i].Bomno : this.Products[i].ChildGroupNo ? this.Products[i].ChildGroupNo : '',
          BatchNumber: this.Products[i].BatchNumber,
          BarCode: this.Products[i].BarCode,
          PdImgs: this.Products[i].PdImgs
        }
        console.log(this.Products[i], 'this.Products[i]')
        ProductModels.push(o)
        console.log(ProductModels, 'senddata')
        this.ProcessModels[i]?.Processes.forEach(item => {
          let o = {
            T: item.T,
            ProgrammeId: item.ProgrammeId,
            ProcessType: item.ProcessType,
            DpId: item.DpId ?? 0,
            WorkDocProcessId: item.WorkDocProcessId ?? 0,
            WorkDocId: this.Products[i].WorkDocId ?? 0,
            ProcessId: item.ProcessId,
            ProcessSn: item.ProcessSn,
            SnType: item.SnType ?? 0,
            ConvertRatio: item.ConvertRatio ?? 1,
            MachineId: item.MachineId ?? 0,
            Length: item.Length ?? 0,
            Width: item.Width ?? 0,
            Multiple: item.Multiple ?? 0,
            RatedLoss: item.RatedLoss ?? 0,
            LossRate: item.LossRate ?? 0,
            PlanIn: item.PlanIn ?? 0,
            PlanOut: item.PlanOut ?? 0,
            PlanOutUnit: item.PlanOutUnit ?? '',
            Requirement: item.Requirement ?? '',
            Status: item.Status ?? 0,
            BatchNumber: item.BatchNumber ?? '',
            BarCode: item.BarCode ?? ''
          }
          ProcessModels.push(o)
        })

        let _Processes = this.deleteProcess.filter(item => {
          return item.WorkDocId === this.Products[i].WorkDocId
        })

        _Processes.forEach(item => {
          let o = {
            T: 2,
            ProgrammeId: item.ProgrammeId,
            ProcessType: item.ProcessType,
            DpId: item.DpId ?? 0,
            WorkDocProcessId: item.WorkDocProcessId ?? 0,
            WorkDocId: item.WorkDocId ?? 0,
            ProcessId: item.ProcessId,
            ProcessSn: item.ProcessSn,
            SnType: item.SnType ?? 0,
            ConvertRatio: item.ConvertRatio ?? 1,
            MachineId: item.MachineId ?? 0,
            Length: item.Length ?? 0,
            Width: item.Width ?? 0,
            Multiple: item.Multiple ?? 0,
            RatedLoss: item.RatedLoss ?? 0,
            LossRate: item.LossRate ?? 0,
            PlanIn: item.PlanIn ?? 0,
            PlanOut: item.PlanOut ?? 0,
            PlanOutUnit: item.PlanOutUnit ?? '',
            Requirement: item.Requirement ?? '',
            Status: item.Status ?? 0,
            BatchNumber: item.BatchNumber ?? '',
            BarCode: item.BarCode ?? ''
          }
          ProcessModels.push(o)
        })

        console.log('ProcessModels', ProcessModels)

        this.DetailModels[i]?.DetailModels.forEach(item => {
          let o = {
            T: item.T,
            WorkDocMaterialId: item.WorkDocMaterialId,
            WorkDocId: this.Products[i].WorkDocId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Ration: item.Ration,
            RationUnit: item.RationUnit,
            Quantity: item.qua,
            QuantityUnit: item.PdUnitId,
            PropertyId: item.PropertyId ?? 0,
            Rate: item.Rate,
            Loss: item.Loss,
            ChildTeProductId: item.ChildTeProductId ?? 0,
            MouldBomNo: item.MouldBomNo,
            ChildGroupNo: item.add ? item.ChildBomNo : item.ChildGroupNo ? item.ChildGroupNo : '',
            OutWarehouseId: item.WarehouseId,
            BatchNumber: item.BatchNumber,
            BarCode: item.BarCode ?? ''
          }
          MaterialModels.push(o)
        })
        console.log('MaterialModels', MaterialModels)

        let {
          WorkDocId,
          WorkDocNo = '',
          SchedulingType = 0,
          DpId = 0,
          MaintenanceId = 0,
          ProductionType,
          ProductionDpId = 0,
          DocDate,
          EndTime,
          Remark = '',
          qua,
          StockQuantity,
          ExistQuantity,
          StartTime,
          PickingWarehouseId = PickingWarehouseId ?? 0,
          PickingWarehousePositionId,
          ProcessStage,
          BatchNumber,
          BarCode,
          Wages
        } = this.Products[i]
        if (DpId == null) {
          DpId = 0
        }
        if (MaintenanceId == null) {
          MaintenanceId = 0
        }
        let { start } = this.cycleChange('今天')
        if (StartTime) {
          start = StartTime
        }
        SchedulingType = SchedulingType ?? 0
        DpId = DpId ?? 0
        MaintenanceId = MaintenanceId ?? 0
        ProductionDpId = ProductionDpId ?? 0
        let Quantity = qua - StockQuantity > 0 ? qua - StockQuantity : qua

        let data = {
          Stage: ProcessStage,
          WorkDocType: 0,
          ProductType: 0,
          StartTime: start,
          WorkDocId,
          WorkDocNo,
          EndTime,
          SchedulingType,
          DpId,
          MaintenanceId,
          ProductionType,
          ProductionDpId,
          DocDate,
          Remark,
          Quantity,
          PickingWarehouseId: PickingWarehouseId ?? 0,
          PickingWarehousePositionId,
          BatchNumber,
          BarCode,
          Wages,
          batchShowEndTime: this.batchShowEndTime
        }

        ProductModels = this.filterData(ProductModels)
        console.log(ProductModels, 'productModels')
        ProcessModels = this.filterData(ProcessModels)
        let _MaterialModels_ = this.deleteLineDetailModels.filter(item => {
          return item.pid === this.Products[i].ProductId
        })
        let _MaterialModels = _MaterialModels_.map(item => {
          return item.deleteRow
        })
        MaterialModels = MaterialModels.concat(_MaterialModels)
        MaterialModels = this.filterData(MaterialModels)

        let o1 = {
          ProductModels,
          ProcessModels,
          MaterialModels,
          ...data
        }

        console.log(o1, '哦33')
        arr.push(o1)
      }

      // 需要删除的
      length = this.deleteProducts.length
      for (let i = 0; i < length; ++i) {
        let ProductModels = []
        let ProcessModels = []
        let MaterialModels = []

        // 对默认值进行设置
        let o = {
          T: this.deleteProducts[i].T,
          WorkDocProductId: this.deleteProducts[i].WorkDocProductId,
          WorkDocId: this.deleteProducts[i].WorkDocId,
          ProductId: this.deleteProducts[i].ProductId,
          PdUnitId: this.deleteProducts[i].PdUnitId,
          ProgrammeId: this.deleteProcessModels[i]?.ProgrammeId ?? 0,
          ColorId: this.deleteProducts[i].ColorId,
          Quantity: this.deleteProducts[i].qua,
          TeProductId: this.deleteProducts[i].TeProductId ?? 0,
          StockQuantity: this.deleteProducts[i].StockQuantity,
          ExistQuantity: this.deleteProducts[i].ExistQuantity,
          SourceDtsId: 0,
          RpType: this.deleteProducts[i].ProcessStage,
          RpRequirement: this.deleteProducts[i].RpRequirement ?? '',
          SnType: this.deleteProducts[i].SnType ?? 0,
          Loss: this.deleteProducts[i].Loss ?? 0,
          Status: this.deleteProducts[i].Status ?? 0,
          OrderNo: this.deleteProducts[i].OrderProductNo,
          WorkDocNo: this.deleteProducts[i].WorkDocNo,
          PdImgs: this.deleteProducts[i].PdImgs
        }

        ProductModels.push(o)

        this.deleteProcessModels[i]?.Processes.forEach(item => {
          let o = {
            T: item.T,
            ProgrammeId: item.ProgrammeId,
            ProcessType: item.ProcessType,
            DpId: item.DpId ?? 0,
            WorkDocProcessId: item.WorkDocProcessId ?? 0,
            WorkDocId: item.WorkDocId ?? 0,
            ProcessId: item.ProcessId,
            ProcessSn: item.ProcessSn,
            SnType: item.SnType ?? 0,
            ConvertRatio: item.ConvertRatio ?? 1,
            MachineId: item.MachineId ?? 0,
            Length: item.Length ?? 0,
            Width: item.Width ?? 0,
            Multiple: item.Multiple ?? 0,
            RatedLoss: item.RatedLoss ?? 0,
            LossRate: item.LossRate ?? 0,
            PlanIn: item.PlanIn ?? 0,
            PlanOut: item.PlanOut ?? 0,
            PlanOutUnit: item.PlanOutUnit ?? '',
            Requirement: item.Requirement ?? '',
            Status: item.Status ?? 0
          }
          ProcessModels.push(o)
        })

        this.deleteDetailModels[i]?.DetailModels.forEach(item => {
          let o = {
            T: item.T,
            WorkDocMaterialId: item.WorkDocMaterialId,
            WorkDocId: item.WorkDocId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Ration: item.Ration,
            RationUnit: item.RationUnit,
            Quantity: item.qua,
            QuantityUnit: item.PdUnitId,
            PropertyId: item.PropertyId ?? 0,
            Rate: item.Rate,
            Loss: item.Loss,
            ChildTeProductId: item.ChildTeProductId ?? 0,
            MouldBomNo: item.MouldBomNo,
            OutWarehouseId: item.WarehouseId
          }
          MaterialModels.push(o)
        })

        let {
          WorkDocId,
          WorkDocNo = '',
          SchedulingType = 0,
          DpId = 0,
          MaintenanceId = 0,
          ProductionType,
          ProductionDpId = 0,
          DocDate,
          EndTime,
          Remark = '',
          qua,
          StockQuantity,
          ExistQuantity,
          StartTime,
          PickingWarehouseId = PickingWarehouseId ?? 0,
          PickingWarehousePositionId,
          ProcessStage
        } = this.deleteProducts[i]
        if (DpId == null) {
          DpId = 0
        }
        if (MaintenanceId == null) {
          MaintenanceId = 0
        }
        let { start } = this.cycleChange('今天')
        if (StartTime) {
          start = StartTime
        }

        SchedulingType = SchedulingType ?? 0
        DpId = DpId ?? 0
        MaintenanceId = MaintenanceId ?? 0
        ProductionDpId = ProductionDpId ?? 0
        let Quantity = qua - StockQuantity > 0 ? qua - StockQuanity : qua

        let data = {
          Stage: ProcessStage,
          WorkDocType: 0,
          ProductType: 0,
          StartTime: start,
          WorkDocId,
          WorkDocNo,
          EndTime,
          SchedulingType,
          DpId,
          MaintenanceId,
          ProductionType,
          ProductionDpId,
          DocDate,
          Remark,
          Quantity,
          PickingWarehouseId: PickingWarehouseId ?? 0,
          PickingWarehousePositionId,
          batchShowEndTime: this.batchShowEndTime
        }

        ProductModels = this.filterData(ProductModels)
        console.log(ProductModels, 'productModels2')
        ProcessModels = this.filterData(ProcessModels)
        let _MaterialModels_ = this.deleteLineDetailModels.filter(item => {
          return item.pid === this.Products[i].ProductId
        })
        let _MaterialModels = _MaterialModels_.map(item => {
          return item.deleteRow
        })
        MaterialModels = MaterialModels.concat(_MaterialModels)
        MaterialModels = this.filterData(MaterialModels)

        let o1 = {
          ProductModels,
          ProcessModels,
          MaterialModels,
          ...data
        }
        console.log(o1, '哦')

        arr.push(o1)
      }

      return arr

      // let arr = [];
      // let length =  this.Products.length;

      // for(let i = 0; i < length; ++i){
      //   let ProductModels = [];
      //   let ProcessModels = [];
      //   let MaterialModels = [];
      //   let o1 = {
      //     T: this.Products[i].T,
      //     WorkDocProductId: this.Products[i].WorkDocProductId || 0,
      //     WorkDocId: this.Products[i].WorkDocId,
      //     ProductId: this.Products[i].ProductId	,
      //     PdUnitId: this.Products[i].PdUnitId,
      //     TebomId: this.Products[i].TebomId	,
      //     ProgrammeId: this.Products[i].ProgrammeId,
      //     ColorId: this.Products[i].ColorId	,
      //     Quantity: this.Products[i].qua,
      //     StockQuantity: this.Products[i].StockQuantity || 0,
      //     SourceDtsId: 0,
      //     RpType: this.Products[i].ProcessStage,
      //     RpRequirement: "",
      //     SnType: 0,
      //     Loss: 0,
      //     Status: 0,
      //     OrderNo: this.Products[i].OrderProductNo,
      //     WorkDocNo: this.Products[i].WorkDocNo || "",
      //   };

      //   let {WorkDocId, WorkDocNo = "", SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,EndTime,Remark = ""} = this.Products[i];
      //   if(DpId == null){
      //     DpId = 0
      //   }
      //   if(MaintenanceId == null){
      //     MaintenanceId = 0
      //   }
      //   let {start} = this.cycleChange('今天')
      //   SchedulingType = SchedulingType ?? 0;
      //   DpId = DpId ?? 0;
      //   MaintenanceId = MaintenanceId ?? 0;
      //   ProductionDpId = ProductionDpId ?? 0;
      //   let data = {
      //     Stage: 3,
      //     WorkDocType: 0,
      //     ProductType: 0,
      //     StartTime: start,
      //     WorkDocId, WorkDocNo,
      //     EndTime,
      //     SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,Remark
      //   }
      //   ProductModels.push(o1)

      //   this.ProcessModels[i].Processes.forEach(item => {
      //   let o2 = {
      //     T: item.T,
      //     ProgrammeId: item.ProgrammeId,
      //     ProcessType: item.ProcessType,
      //     DpId: item.DpId,
      //     WorkDocProcessId: item.WorkDocProcessId,
      //     WorkDocId:item.WorkDocId,
      //     ProcessId:item.ProcessId,
      //     ProcessSn:item.ProcessSn,
      //     SnType:item.SnType,
      //     ConvertRatio:item.ConvertRatio,
      //     MachineId:item.MachineId,
      //     Length:item.Length,
      //     Width:item.Width,
      //     Multiple:	item.Multiple,
      //     RatedLoss:item.RatedLoss,
      //     LossRate:	item.LossRate,
      //     PlanIn:	item.PlanIn,
      //     PlanOut:	item.PlanOut,
      //     PlanOutUnit:item.PlanOutUnit,
      //     Requirement:item.Requirement,
      //     Status:item.Status,
      //   }
      //   ProcessModels.push(o2)

      // })

      // this.DetailModels[i].DetailModels.forEach(item => {
      //   let o3 = {
      //     T: item.T,
      //     WorkDocMaterialId: item.WorkDocMaterialId,
      //     WorkDocId: item.WorkDocId,
      //     ProductId: item.ProductId,
      //     ColorId: item.ColorId,
      //     Ration: item.Ration,
      //     RationUnit: item.RationUnit,
      //     Quantity: item.qua,
      //     QuantityUnit: item.PdUnitId,
      //     PropertyId: item.Property,
      //     Rate: item.Rate,
      //     Loss: item.Loss,
      //   }
      //   MaterialModels.push(o3)

      // })

      // ProductModels = this.filterData(ProductModels)
      // ProcessModels = this.filterData(ProcessModels)
      // MaterialModels = MaterialModels.concat(this.deleteLineDetailModels)
      // MaterialModels = this.filterData(MaterialModels)

      //   let obj = {
      //     ProductModels,
      //     ProcessModels,
      //     MaterialModels,
      //     ...data
      //   }

      //   arr.push(obj)
      // }

      // // 删除
      // let deleteProductsLength =  this.deleteProducts.length;

      // for(let i = 0; i < deleteProductsLength; ++i){
      //   let ProductModels = [];
      //   let ProcessModels = [];
      //   let MaterialModels = [];
      //   let o1 = {
      //     T: this.deleteProducts[i].T,
      //     WorkDocProductId: this.deleteProducts[i].WorkDocProductId || 0,
      //     WorkDocId: this.deleteProducts[i].WorkDocId,
      //     ProductId: this.deleteProducts[i].ProductId	,
      //     PdUnitId: this.deleteProducts[i].PdUnitId,
      //     TebomId: this.deleteProducts[i].TebomId	,
      //     ProgrammeId: this.Products[i].ProgrammeId,
      //     ColorId: this.deleteProducts[i].ColorId	,
      //     Quantity: this.deleteProducts[i].qua,
      //     StockQuantity: this.deleteProducts[i].StockQuantity || 0,
      //     SourceDtsId: 0,
      //     RpType: this.deleteProducts[i].ProcessStage,
      //     RpRequirement: "",
      //     SnType: 0,
      //     Loss: 0,
      //     Status: 0,
      //     OrderNo: this.deleteProducts[i].OrderProductNo,
      //     WorkDocNo: this.deleteProducts[i].WorkDocNo || "",
      //   };

      //   let {

      //     WorkDocId, WorkDocNo = "", SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,EndTime,Remark = ""} = this.deleteProducts[i];
      //   if(DpId == null){
      //     DpId = 0
      //   }
      //   if(MaintenanceId == null){
      //     MaintenanceId = 0
      //   }
      //   SchedulingType = SchedulingType ?? 0;
      //   DpId = DpId ?? 0;
      //   MaintenanceId = MaintenanceId ?? 0;
      //   ProductionDpId = ProductionDpId ?? 0;
      //   let {start} = this.cycleChange('今天')
      //   let data = {
      //     Stage: 3,
      //     WorkDocType: 0,
      //     ProductType: 0,
      //     StartTime: start,
      //     WorkDocId, WorkDocNo,
      //     EndTime,
      //     SchedulingType,DpId,MaintenanceId,ProductionType,ProductionDpId,DocDate,Remark,
      //   }
      //   ProductModels.push(o1)

      //   this.deleteProcessModels[i].Processes.forEach(item => {
      //   let o2 = {
      //     T: item.T,
      //     ProgrammeId: item.ProgrammeId,
      //     ProcessType: item.ProcessType,
      //     DpId: item.DpId,
      //     WorkDocProcessId: item.WorkDocProcessId,
      //     WorkDocId:item.WorkDocId,
      //     ProcessId:item.ProcessId,
      //     ProcessSn:item.ProcessSn,
      //     SnType:item.SnType,
      //     ConvertRatio:item.ConvertRatio,
      //     MachineId:item.MachineId,
      //     Length:item.Length,
      //     Width:item.Width,
      //     Multiple:	item.Multiple,
      //     RatedLoss:item.RatedLoss,
      //     LossRate:	item.LossRate,
      //     PlanIn:	item.PlanIn,
      //     PlanOut:	item.PlanOut,
      //     PlanOutUnit:item.PlanOutUnit,
      //     Requirement:item.Requirement,
      //     Status:item.Status,
      //   }
      //   ProcessModels.push(o2)

      // })

      // this.deleteDetailModels.forEach(item => {
      //   let o3 = {
      //     T: item.T,
      //     WorkDocMaterialId: item.WorkDocMaterialId,
      //     WorkDocId: item.WorkDocId,
      //     ProductId: item.ProductId,
      //     ColorId: item.ColorId,
      //     Ration: item.Ration,
      //     RationUnit: item.RationUnit,
      //     Quantity: item.qua,
      //     QuantityUnit: item.PdUnitId,
      //     PropertyId: item.Property,
      //     Rate: item.Rate,
      //     Loss: item.Loss,
      //   }
      //   MaterialModels.push(o3)

      // })

      // ProductModels = this.filterData(ProductModels)
      // ProcessModels = this.filterData(ProcessModels)
      // MaterialModels = this.filterData(MaterialModels)

      //   let obj = {
      //     ProductModels,
      //     ProcessModels,
      //     MaterialModels,
      //     ...data
      //   }

      //   arr.push(obj)
      // }

      // return arr;
    },

    setDetailModels(data) {
      data = JSON.parse(JSON.stringify(data))
      let ids = this.Products.map(item => {
        return item.ProductId
      })

      let ProcessModelsNames = this.ProcessModels.map(item => {
        return item.ProductId
      })

      let DetailModelsName = this.DetailModels.map(item => {
        return item.ProductId
      })

      let _ProcessModels = []
      let _DetailModels = []

      this.deleteProducts = []
      this.deleteProcessModels = []
      this.deleteDetailModels = []

      // 先删除
      data.forEach((item, i) => {
        if (item.delete) {
          let pname = item.Pname
          let productId = item.ProductId

          let DetailModelsIndex = this.DetailModels.findIndex(item => {
            return pname === item.Pname
          })

          let ProcessModelsIndex = this.ProcessModels.findIndex(item => {
            return pname === item.Pname
          })

          let index = data.findIndex(item => {
            return pname === item.Pname
          })

          data.splice(index, 1)

          let ProductsIndex = this.Products.findIndex(item => {
            return productId === item.ProductId
          })

          if (item.T === 2) {
            this.Products[ProductsIndex].T = 2
            this.ProcessModels[ProcessModelsIndex].Processes.forEach(item => {
              item.T = 1
            })
            this.DetailModels[DetailModelsIndex].DetailModels.forEach(item => {
              item.T = 2
            })

            this.deleteProducts.push(this.Products[ProductsIndex])
            this.deleteProcessModels.push(this.ProcessModels[ProcessModelsIndex])
            this.deleteDetailModels.push(...this.DetailModels[DetailModelsIndex].DetailModels)
          }

          this.DetailModels.splice(DetailModelsIndex, 1)
          this.ProcessModels.splice(ProcessModelsIndex, 1)
          this.Products.splice(ProductsIndex, 1)

          ids = this.Products.map(item => {
            return item.ProductId
          })

          ProcessModelsNames = this.ProcessModels.map(item => {
            return item.Pname
          })

          DetailModelsName = this.DetailModels.map(item => {
            return item.Pname
          })
        }
      })

      // 过滤出非添加的数据
      let newData = data.filter(item => {
        return item.add == null
      })

      console.log('newData=====', newData)

      // 匹配存在的数据
      newData.forEach((item, i) => {
        item.OrderProductNo = this.OrderProductNo
        let index = ids.indexOf(item.lastProductId)

        if (index !== -1) {
          this.$set(item, 'TebomId', this.Products[index].TebomId)
          this.$set(item, 'TespecialBomId', this.Products[index].TespecialBomId)
          this.$set(item, 'ProgrammeId', this.Products[index].ProgrammeId)

          let tType = item.T == null ? this.Products[index].T : item.T
          this.$set(item, 'T', tType)
          this.$set(item, 'WorkDocId', this.Products[index].WorkDocId)
          this.$set(item, 'WorkDocProductId', this.Products[index].WorkDocProductId)
          this.$set(item, 'WorkDocNo', this.Products[index].WorkDocNo)
          this.$set(item, 'StockQuantity', this.Products[index].StockQuantity)
          this.$set(item, 'ExistQuantity', this.Products[index].ExistQuantity)
          this.$set(item, 'SchedulingType', this.Products[index].SchedulingType)
          this.$set(item, 'DpId', this.Products[index].DpId)
          this.$set(item, 'MaintenanceId', this.Products[index].MaintenanceId)
          this.$set(item, 'ProductionType', this.Products[index].ProductionType)
          this.$set(item, 'ProductionDpId', this.Products[index].ProductionDpId)
          this.$set(item, 'DocDate', this.Products[index].DocDate)
          this.$set(item, 'EndTime', this.Products[index].EndTime)
          this.$set(item, 'Remark', this.Products[index].Remark)

          let ProcessModelsNameIndex = ProcessModelsNames.indexOf(item.lastProductId)
          let DetailModelsNamIndex = DetailModelsName.indexOf(item.lastProductId)
          console.log('-----this.ProcessModels----', ProcessModelsNameIndex, this.ProcessModels)

          let o = {
            Pno: item.Pno,
            Pname: item.Pname,
            ProductId: item.ProductId,
            ProgrammeName: this.ProcessModels[ProcessModelsNameIndex].ProgrammeName,
            ProgrammeId: this.ProcessModels[ProcessModelsNameIndex].ProgrammeId,
            Processes: this.ProcessModels[ProcessModelsNameIndex].Processes
          }

          _ProcessModels.push(o)

          let o1 = {
            Pname: item.Pname,
            ProductId: item.ProductId,
            DetailModels: this.DetailModels[DetailModelsNamIndex].DetailModels
          }

          _DetailModels.push(o1)
        } else {
          this.ProcessModels[i].Pname = item.Pname
          this.ProcessModels[i].Pno = item.Pno
          this.ProcessModels[i].ProductId = item.ProductId

          this.ProcessModels[i].Processes = []
          this.ProcessModels[i].ProgrammeName = ''

          this.DetailModels[i].Pname = item.Pname
          this.DetailModels[i].Pno = item.Pno
          this.DetailModels[i].ProductId = item.ProductId
          this.DetailModels[i].DetailModels = []
        }
      })

      let addData = data.filter(item => {
        return item.add
      })

      addData.forEach((item, i) => {
        if (item.add) {
          this.$set(item, 'T', 0)
          this.$set(item, 'WorkDocId', 0)
          this.$set(item, 'WorkDocProductId', 0)
          this.$set(item, 'WorkDocNo', '')
          this.$set(item, 'StockQuantity', 0)
          this.$set(item, 'ExistQuantity', 0)
          this.$set(item, 'SchedulingType', 0)
          this.$set(item, 'DpId', null)
          this.$set(item, 'MaintenanceId', null)
          this.$set(item, 'ProductionType', item.ProductNature)
          this.$set(item, 'ProductionDpId', item.DefaultSupplier)
          this.$set(item, 'DocDate', this.$commonJs.getToday())
          this.$set(item, 'EndTime', '')
          this.$set(item, 'Remark', '')

          this.$set(item, 'TeProductDetailId', 0)
          this.$set(item, 'TebomId', 0)
          this.$set(item, 'TespecialBomId', 0)
          this.$set(item, 'ProgrammeId', 0)

          _ProcessModels.push({
            Pno: item.Pno,
            Pname: item.Pname,
            ProductId: item.ProductId,
            ProgrammeName: '',
            ProgrammeId: 0,
            Processes: []
          })

          _DetailModels.push({
            Pname: item.Pname,
            ProductId: item.ProductId,
            DetailModels: []
          })

          item.OrderProductNo = this.OrderProductNo
        }
      })

      newData.push(...addData)

      this.Products = newData
      this.ProcessModels = _ProcessModels

      console.log('-----_DetailModels----', JSON.parse(JSON.stringify(_DetailModels)))

      this.Products.forEach((item, i) => {
        let qua = item.qua
        console.log(`---_DetailModels[${i}]---`, _DetailModels[i])
        _DetailModels[i].DetailModels.forEach(v => {
          v.qua = qua / v.rateQua
        })
      })

      console.log('_DetailModels===', _DetailModels)

      this.DetailModels = _DetailModels
    },
    get_data() {
      let datas = []
      this.DetailModels.forEach(item => {
        item.DetailModels.forEach(v => {
          let {
            T,
            Pno,
            Pname,
            ProductId,
            ProductSpec,
            PdUnitId,
            PdUnitName,
            ColorId,
            ColorName,
            Quantity,
            ImgUrl,
            ProcessStage,
            ProduceTypeName,
            StockQuantity,
            ExistQuantity,
            Property,
            PropertyName,
            MouldBomNo,
            UseProcess,
            UseColor,
            TeProductId,
            add,
            qua,
            MouldId,
            MouldName,
            MouldNo,
            lastProductId,
            currentProductId,
            ProductNature,
            DefaultSupplier
          } = v
          let o = {
            T,
            Pno,
            Pname,
            ProductId,
            ImgUrl,
            ProductSpec,
            PdUnitId,
            PdUnitName,
            ColorId,
            ColorName,
            Quantity,
            ImgUrl,
            ProcessStage,
            ProduceTypeName,
            StockQuantity,
            ExistQuantity,
            Property,
            PropertyName,
            MouldBomNo,
            UseProcess,
            UseColor,
            TeProductId,
            add,
            qua,
            MouldId,
            MouldName,
            MouldNo,
            lastProductId,
            currentProductId,
            ProductNature,
            DefaultSupplier
          }
          datas.push(o)
        })
      })

      datas = JSON.parse(JSON.stringify(datas))

      datas = datas.concat(this.delDetailModels)

      return datas
    },
    clearData() {
      this.DetailModels.forEach(item => {
        item.DetailModels.forEach(v => {
          if (v.add) {
            this.$delete(v, 'add')
          }
          v.lastProductId = v.currentProductId
        })
      })

      this.delDetailModels = []
    },
    /** 批量操作 */
    handleSelectionChange(val) {
      this.selList = val
    },
    /** 批量-单据日期 */
    onDocDate() {
      this.Products = this.Products.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.MakeEmpId === obj1.MakeEmpId && obj2.MouldId === obj1.MouldId)
        if (duplicateObj) {
          obj1.DocDate = this.batchDocDate
        }
        return obj1
      })
      this.batchDocDate = ''
    },
    /** 批量-单据日期 */
    onDocEndTime() {
      this.Products = this.Products.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.ProductId === obj1.ProductId)
        if (duplicateObj) {
          obj1.EndTime = this.batchEndTime
        }
        return obj1
      })
      this.batchShowEndTime = this.batchEndTime
      this.batchEndTime = ''
    },
    /** 预入出仓库 切换时 赋值预入库位 */
    onWarehouse(val, row) {
      row.PickingWarehousePositionId = null
      row.OutWarehousePositionId = null
    },
    onChangeWarehousePosition(e, row, id) {
      if (e) {
        const o = { Status: 1, WarehouseId: id }
        this.warehousePositionApi.list(o).then(res => {
          let list = res.Data.map(item => {
            return {
              WarehousePositionId: item.WarehousePositionId,
              WarehousePositionName: item.WarehousePositionName
            }
          })
          this.$nextTick(() => {
            row.WarehousePositionList = list
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
.flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
.flex2 {
  display: flex;
}
.mr8 {
  margin-right: 8px;
}
</style>
